/* eslint-disable max-len */
module.exports = {
  aOfB: '{a} av {b}',
  about: 'Om',
  aboutThisItem: 'Om denna artikel',
  accessApiKeyManager: 'Få åtkomst till API Key Manager för denna hyresgäst.',
  accessControls: 'Åtkomstkontroller',
  accessControlsCopiedText: 'Åtkomstkontroller uppdateras omedelbart. Mediesäkerhetsprivilegier uppdateras inom några minuter.',
  accessControlsCopiedTitle: 'Åtkomstkontroller har kopierats',
  accessControlsCopyConfirmation: 'Detta tar bort alla befintliga åtkomstkontroller från {to} och ersätter dem med åtkomstkontroller från {from}. Denna åtgärd kan inte ångras.',
  accessControlsDescription: 'Åtkomstkontroller definierar vem som kan se dessa medier, baserat på valda organisationer och mediekategorier.',
  accessControlsHelpText: 'Hantera åtkomstkontroller för organisationen. Användare kan endast komma åt de listade medium som de har behörighet att visa i de mediumkategorier som de tillhör. Det kan ta lite tid att bearbeta flera medium som tillämpas på en organisation. Vänta tills de nya inställningarna har aktiverats och använd uppdateringsknappen.',
  accessControlsIndeterminance: 'Obs! Överordnade organisationer har alltid åtkomst till innehåll som tilldelats någon av deras underordnade organisationer.',
  accessControlsRefreshWarning: 'Dina ändringar har inte sparats. Om du uppdaterar kommer de att raderas. Vill du fortsätta?',
  accessControlsSaveSuccess: 'Åtkomstkontroller har sparats.',
  accessControlsTitleSection: 'När åtkomstkontroller tillämpas i organisationen överförs de automatiskt till följande organisationer genom omvänd arv:',
  accessControlsTooltip: 'Organisationer har även åtkomst till innehåll som dess underordnade organisationer har åtkomst till. I tabellen nedan anges inte innehåll som organisationen har åtkomst till genom indirekt delegering uppåt eller omvänd arv.',
  account: 'Konto',
  accountErrorMessage: 'Felmeddelande för konto',
  accountErrorMessageWarning: 'Fältet accountErrorMessage i databasen kommer att ställas in som "Ej tillåtet" för hyresgästen.',
  action: 'Åtgärd | Åtgärder',
  actionDelete: 'ta bort',
  actionLoad: 'läs in',
  actionPaste: 'Klistra in',
  actionRun: 'kör',
  actionSave: 'Spara',
  actionUndoWarning: 'Denna åtgärd kan inte ångras.',
  actionUpload: 'ladda upp',
  actualSize: 'Verklig storlek',
  add: 'Lägg till',
  addABookText: 'Lägg till en bok',
  addABookToStart: '{addABookText} för att komma igång.',
  addAForm: 'Lägg till ett Formulär för att komma igång',
  addAFormOnly: 'Lägg till ett formulär',
  addAMedia: 'Lägg till media',
  addAPIKey: 'Lägg till en API-Nyckel',
  addAPartCollection: 'Lägg till en {partCollection} för att komma igång.',
  addAPrintSettingText: 'Lägg till en utskriftsinställning',
  addAPrintSettingToStart: '{addAPrintSettingText} för att komma igång.',
  addASharedCart: 'Lägg till en delad kundvagn',
  addATag: 'Lägg till en etikett',
  addATemplate: 'Lägg till en mall',
  addAllPartsCart: 'Lägg till alla delar i varukorgen',
  addAnOrderQuoteEmailFormat: 'Lägg till ett format för en beställning, förfrågan eller ett mejl',
  addBooks: 'Lägg till böcker',
  addBrowseFlow: 'Lägg till ett flöde',
  addChapter: 'Lägg till Kapitel',
  addChildBrowseFlow: 'Lägg till underordnat flöde',
  addComment: 'Lägg till en kommentar',
  addExistingPart: 'Lägg till en befintlig artikel',
  addGroupsToUsers: 'Lägg till {groups} grupper till {users} användare',
  addItem: 'Lägg till {item}',
  addMedia: 'Lägg till medium',
  addPages: 'Lägg till sidor',
  addPart: 'Lägg till en artikel',
  addReports: 'Lägg till Rapporter',
  addRootBrowseFlow: 'Lägg till rotflöde',
  addRow: 'Lägg till rad',
  addTemplates: 'Lägg till mallar',
  addToCartMessage: '{partNumber} har lagts till',
  addToUserGroup: 'Lägg till i Grupper',
  addWidgetKey: 'Lägg till en widgetnyckel',
  addedOn: 'Tillagt den',
  additionalInformation: 'Mer information',
  additionalNotification: 'Ytterligare meddelande',
  additionalPartNumberDescription: 'Använd som ytterligare fält för artikelnummer',
  address: 'Adress | Adresser',
  addressInUse: 'En adress är för närvarande inställd som standardadress och kan inte tas bort',
  addressInUseSubtitle: 'Om du vill ta bort denna adress måste du först ta bort den som standardadress.',
  addressLine: 'Adressrad {number}',
  addressState: {
    confirmationMessage: 'Följande adresser är inte verifierade.',
    confirmationTitle: 'Är du säker på att du vill fortsätta med icke verifierade adresser?',
    disabledVerification: 'Adressverifieringen kommer att inaktiveras för fältet för inlämning av beställning/anbud',
    enteredAddress: 'Angiven adress',
    failedToFetchSuggestions: 'Kunde inte hämta adressförslagen.',
    failedToLoadDetails: 'Kunde inte ladda adressdetaljer.',
    incomplete: 'Ofullständig adress',
    missingSubpremise: 'Fullständig intern adress saknas',
    noSuggestions: 'Inga förslag hittades. Vänligen redigera adressen för förslagen.',
    selectAddress: '(vänligen välj ett alternativ)',
    subpremiseMessage: 'Denna adress verkar vara för en lägenhet eller en kontorsbyggnad. Vänligen lägg till ditt enhets-, lägenhets- eller svitnummer för att komplettera adressen.',
    suggested: 'Föreslagna adresser',
    unverified: 'Icke verifierad adress',
    unverifiedHelpText: 'Välj en sparad adress eller redigera denna adress eller lägg till en ny adress',
    unverifiedMessage: 'Vi kan inte verifiera denna adress för leverans.',
    verified: 'Verifierad adress'
  },
  admin: 'Admin',
  adminCenter: 'Admincenter',
  adminCenterBanner: {
    bodyLabel: 'Bannerns kropp',
    enableLabel: 'Aktivera banner för administratör',
    headerGreenOption: 'Grön',
    headerLabel: 'Banner för sidhuvud',
    headerRedOption: 'Röd',
    headerYellowOption: 'Gul',
    title: 'Banner för administrationscentral',
    typeLabel: 'Typ av banner'
  },
  adminCenterMessage: 'Administrativt center för innehåll, användare, biblioteksinställningar, rapportering och export',
  adminMessage: 'Funktioner läggs till när de blir tillgängliga',
  administration: 'Administration',
  advancedFilters: 'Avancerade filter',
  affectedBookMedia: '{count} Bokmedia kommer att uppdateras.',
  affectedProductPages: '{count} Produktsidorna kommer att uppdateras.',
  affectedTemplateMedia: '{count} Bokmallar kommer att uppdateras.',
  after: 'Efter',
  aggregatedFromChildren: 'Sammanslaget från underordnade',
  aiAlgorithm: 'AI-skanner',
  algorithm: 'Algoritm',
  alignHorizontal: 'Justera Vågrätt',
  alignVertical: 'Justera Lodrätt',
  all: 'Alla',
  allLibraryPages: 'Alla sidor i biblioteket',
  allPagesAndBooks: 'Alla sidor och böcker',
  allUsersDisabled: 'Alla användare som hör till hyresgästen kommer att inaktiveras.',
  alphanumeric: 'Alfanumeriskt',
  analyticsJSON: 'Analyser JSON',
  andCountMore: 'och {count} andra ...',
  announcement: 'Meddelande | Meddelanden',
  any: 'Valfri',
  apiAuthHeader: 'Rubrik för Godkännande av API',
  apiKey: 'API-Nyckel | API-Nycklar',
  apiKeyAdmin: 'Administratör för API-Nycklar',
  apiKeyCopied: 'Värde för Rubrik för Godkännande av API kopierat till Urklipp',
  apiKeyDeleteMsg: 'Radering av denna API-Nyckel kommer att inaktivera dess användning av integreringar',
  apiKeyDeleteTitle: 'Är du säker på att du vill radera denna API-Nyckel?',
  apiKeyDeleted: 'API-Nyckel raderad',
  apiKeyDeletedError: 'Fel vid radering av API-Nyckel',
  apiKeyInstructions: 'Nyckel kommer att genereras när den Sparas',
  apiKeyManager: 'Hantering av API-Nycklar',
  apiKeyNameEmpty: 'Namn får inte vara tomt',
  apiKeyRegenError: 'Fel när API-Nyckel återskapades',
  apiKeyRegenMsg: 'Återskapande av denna API-Nyckel kan inaktivera befintliga integreringar',
  apiKeyRegenTitle: 'Är du säker på att du vill återskapa denna API-Nyckel?',
  apiKeySaved: 'API-Nyckel Sparad',
  apiKeyType: 'Typ av API-nyckel',
  appliesTo: 'Gäller för',
  appliesToEmpty: 'Kräver att minst en enhetstyp har valts',
  appliesToPopulated: 'Ställ in vilka enheter taggen kan tillämpas på',
  apply: 'Tillämpa',
  applyItem: 'Tillämpa {item}',
  applyToChildItems: 'Tillämpa på underordnad {item}',
  applyToPartOnly: 'Använd endast på denna del',
  april: 'April',
  areYouSure: 'Är du säker på att du vill ta bort {item}?',
  areYouSureCopy: 'Är du säker på att du vill kopiera {item}?',
  areYouSureYouWantToDisableTheTenant: 'Är du säker på att du vill inaktivera hyresgästen?',
  area: 'Område',
  assembly: 'Sammansättning | Sammansättningar',
  assemblyConfirmationTitle: 'Vill du slutföra Skapa sammansättning?',
  assemblyCreatorHelpText1: 'Med denna funktion kan du infoga en vald sida i böcker på alla platser där denna artikel {partName} finns, vilket automatiskt kopplar artikeln till den valda sidan via en hotpoint-länk. Om du vill kan du begränsa infogningen till bara vissa böcker.',
  assemblyCreatorHelpText2: 'Den valda sidan infogas en gång per bok efter den första förekomsten av {partName}.',
  assemblyCreatorSuccessSubtitle: 'Ändringar i bokens innehållsförteckning och hotpoints utförs omedelbart. Sökresultat visas när indexeringen har slutförts.',
  assemblyCreatorSuccessTitle: 'Förfrågan om att skapa monteringsjobb har skickats',
  assemblyStepOne: 'Steg 1: Välj sidan som ska infogas',
  assemblyStepTwo: 'Steg 2: Välj de böcker där du vill att sidan ska infogas',
  asset: 'Tillgång | Tillgångar',
  assetsNotFound: 'Ingen {type} hittades',
  assignBrowseFlow: 'Tilldela flöde',
  assignMedia: 'Tilldela medium',
  assignMediaToItem: 'Välj medium till detta {item}.',
  assignedOrganizations: 'Tilldelade organisationer',
  associateProductPage: 'Förknippa befintlig produktsida',
  associateProductPageDescription: 'Förknippa produktsidorna till detta media.',
  associateProductPageTip: 'Tips: Om du klickar på "Skapa ny produktsida" öppnas en flik där du kan lägga till en ny produktsida om produkten som du vill förknippa inte existerar ännu. Du måste ändå återvända till den här sidan för att förknippa den nya produktsidan när den har skapats.',
  associateProducts: 'Förknippa produkter',
  atLeastFiveError: 'Vänligen välj ett värde på 5 eller mer.',
  attachRelatedPDFs: 'Bifoga PDF-filer med relaterade artikelsidor',
  attachment: 'Bilaga | Bilagor',
  attachmentEditorDescription: 'Bifoga bilder, videor och dokument direkt till denna enhet. Observera att de kommer att finnas under fliken Relaterat.',
  attachmentEditorDescriptionPP: 'Bifoga bilder, videor och dokument direkt till denna enhet.',
  attachmentFileUploadSizeError: 'Filstorleken överstiger gränsen på 50 MB',
  attachmentView: 'Visa bilagor',
  attributions: 'Attributioner',
  august: 'Augusti',
  autoHideEmptyCards: 'Dölj automatiskt tomma konton',
  autoHotpoint: 'Auto Hotpoint',
  autoPopulate: 'Fyll i automatiskt',
  automaticZoom: 'Automatisk zoom',
  availability: 'Tillgänglighet',
  back: 'Tillbaka',
  backCover: 'Bakre pärm',
  backStitch: 'Bakre häftning',
  backToLibrary: 'Tillbaka till biblioteket',
  backToSearch: 'Tillbaka till sökning',
  badCredentials: 'Ogiltiga autentiseringsuppgifter',
  badDefaultValueMessage: 'Standardvärdet måste innehålla mellan {min} och {max} tecken.',
  bahasaDescription: 'Beskrivning på indonesiska',
  bahasaName: 'Indonesiskt Namn',
  banner: 'Banner',
  banners: 'Banners',
  barColor: 'Stapelfärg',
  before: 'Före',
  beginTypingToFindAnything: 'Börja skriva för att hitta något',
  beta: 'Beta',
  betaAccessKeys: 'Nycklar för beta-tillgång',
  betaReleaseVideo: 'Betaversion av video',
  betaResources: 'Betaresurser',
  blobFinder: 'BLOB-sökare',
  body: 'Brödtext',
  bom: 'BOM',
  bomDefaultSupplier: 'Standardleverantör av BOM',
  bomExportSuccess: 'Exportering av BOM har slutförts',
  bomItem: 'BOM-Artikel',
  bomItems: 'Materialförteckning',
  bomLayout: 'Layout för materiallista',
  bomListOptions: 'Val för Stycklista',
  bomListSettings: 'Inställningar för Stycklista',
  book: 'Bok | Böcker',
  bookInserts: 'Bokinlägg',
  bookLabel: 'Bok | Böcker',
  bookPrintingDisable: 'Inaktivera bokutskrift',
  booksAndPagesDisplay: 'Visning av böcker och sidor',
  boost: 'Boosta sökning',
  boostDescription: 'Lägg till ett värde större än 1,5 för att boosta sökrelevansen av denna tagg över artikelnummer, medieidentifierare och namn',
  boostRangeInvalid: 'Ökning måste vara mellan 0,5 och 100,0',
  border: 'Gräns',
  both: 'Båda',
  bottom: 'Nederst',
  branding: 'Varumärke',
  browse: 'Sök',
  browseComputer: 'Sök på dator',
  browseFlow: 'Sök i flöde | Sök i flöden',
  browseFlowAssigned: 'Tilldelat flöde',
  browseFlowCopyMessage: 'Ange ett unikt namn för det nya flödet.',
  browseFlowDeleteMessage: 'Om ett flöde tas bort tas inte bara flödet bort utan även alla dess underordnade flöden.',
  browseFlowDeleted: 'Webbläsarflöde har raderats',
  browseFlowEmptyState: 'Inga flöden har definierats. {new} för att komma igång.',
  browseFlowHierarchy: 'Bläddra bland flödeshierarki',
  browseFlowMediaCategoryProductPageHelpText: 'Radera sökkriterier för nyligen tillagd "Typ: Produktsida" för att tillämpa ändringarna',
  browseFlowMoveToRoot: 'Släpp nod här för att skapa underordnad på första nivån',
  browseFlowNoAssignedOrgs: 'Inga tilldelade organisationer',
  browseFlowNoExistingCriteria: 'Inga sökkriterier har konfigurerats för detta flöde.  Använd kontrollerna ovan för att välja sökkriterier.',
  browseFlowNoExistingCriteriaBelow: 'Inga sökkriterier har konfigurerats för detta flöde.  Använd kontrollerna nedan för att välja sökkriterier.',
  browseFlowSaveFailed: 'Flödet kunde inte uppdateras',
  browseFlowSaved: 'Flödet har sparats',
  browseFlowSelectionRequired: 'Val av flöde krävs.',
  browseFlowSetDefaultSuccess: 'Standarduppsättning av flöden',
  browseFlowThumbnailDeleteFailTitle: 'Det gick inte att ta bort miniatyrbilden',
  browseFlowThumbnailDeleteSuccessTitle: 'Miniatyrbilden togs bort',
  browseFlowThumbnailUploadFailTitle: 'Det gick inte att ladda upp miniatyrbilden',
  browseFlowThumbnailUploadSuccessTitle: 'Miniatyrbilden har laddats upp',
  browseFlowTooManyOrgs: 'Du har för många organisationer för att kunna använda den nuvarande flödesredigeraren. Kontakta Documoto Support på {email} för hjälp med att redigera dina Documoto-flöden.',
  browserDeprecation: {
    text: 'I linje med att Microsoft utfasar stöd för Internet Explorer (alla versioner) och relaterade säkerhetsproblem, kommer vi inte längre att stödja användaråtkomst till denna webbplats via Internet Explorer (alla versioner) efter 30 september 2021.',
    title: 'Meddelande om utfasning av webbläsare'
  },
  browserPartiallySupport: 'Du kan se estetiska skillnader och andra ändringar i denna webbläsare.',
  buildHotpointLinks: 'Bygg hotpoint-länkar',
  buildHotpointLinksInfo: 'Denna åtgärd tar först bort alla befintliga hotpoint-länkar från bokens sidor och skapar sedan nya hotpoint-länkar mellan artiklar och eventuella matchande sammansättningssidor.',
  buildHotpointLinksTitle: 'Vill du bygga hotpoint-länkar för denna bok?',
  bulkApplyAllOrgs: 'Tillämpa på alla organisationer',
  bulkApplyAllOrgsModalMsg: 'Är du säker på att du vill bevilja åtkomst till detta innehåll för alla organisationer? Klicka på ”bekräfta” för att omedelbart bevilja åtkomst för alla organisationer och spara ändringarna i åtkomstkontrollen.',
  bulkExportConfirm: 'Vill du exportera {n} {unit}?',
  bulkExportLimit: 'Gränsen är {limit} böcker per exportjobb',
  bulkImport: 'Massimport',
  bulkIndexingLane: 'Volym för indexeringsbana',
  bulkInsert: 'Massinlägg',
  bulkPageInsertJob: 'Infoga Sidor i grupp',
  bulkRemoveAllOrgs: 'Ta bort från alla organisationer',
  bulkRemoveAllOrgsModalMsg: 'Är du säker på att du vill ta bort åtkomsten till detta innehåll för alla organisationer? Klicka på ”bekräfta” för att omedelbart ta bort åtkomsten för alla organisationer och spara ändringarna i behörigheter.',
  business: 'Affär',
  button: 'Knappen',
  cameraSettings: 'Kamerainställningar',
  cancel: 'Avbryt',
  cancelAssemblyCreatorSubtitle: 'Din skapade montering bearbetas inte.',
  cancelAssemblyCreatorTitle: 'Kassera din skapade montering?',
  canceled: 'Avbrutet',
  cannotExceed100: 'Får inte överstiga 100 %',
  cannyWidgetLoadFailure: 'Feedbackforum kunde inte laddas',
  cart: 'Kundvagn | Kundvagnar',
  cartBehaviorDisabled: 'Inaktivera kvantitetsprompt för Lägg till i kundvagn',
  cartBehaviorEnabled: 'Aktivera kvantitetsprompt för Lägg till i kundvagn',
  cartBehaviorLabel: 'Kvantitetsbeteende för Lägg till i kundvagn',
  cartColumn: 'Kundvagnskolumn | Kundvagnskolumner',
  cartColumn1: 'Första priskolumn för kundvagn',
  cartColumn2: 'Andra priskolumn för kundvagn',
  cartColumn3: 'Tredje priskolumn för kundvagn',
  cartColumnPartLocationContent1: 'Om denna funktion aktiveras innebär det följande:  ',
  cartColumnPartLocationContent2: 'En artikelrads unikhet i kundvagnen kommer även att baseras på var i innehållet det finns, om tillämpligt.',
  cartColumnPartLocationContent3: 'Denna inställning kan inte inaktiveras på organisationsnivå och kommer att gälla alla användare.',
  cartColumnPartLocationContent4: 'Denna inställning bör inte aktiveras om du har integrerat ”Skicka kundvagn” utan att först kontakta din Documoto Customer Success Manager.',
  cartColumnPartLocationOption: 'Aktivera data om artikelns plats i kundvagnen',
  cartColumnPartLocationTitle: 'Vill du aktivera data om artikelns plats i kundvagnen?',
  cartDisable: 'Inaktivera kundvagn',
  cartEmailFailed: 'Mejl om varukorg gick ej att skicka',
  cartEmailSent: 'Mejl om varukorg har skickats',
  cartEnable: 'Aktivera kundvagn',
  cartErpMessage: 'Har skickats till ERP',
  cartImportError: 'Fel vid import av kundvagn',
  cartLoadedWithItemsRemoved: '{count} artikel eller artiklar raderade eftersom du saknar rättigheter att beställa dem nu',
  cartSaveEnable: 'Aktivera Spara kundvagn',
  cartSharedAddEdit: 'Lägg till/redigera delade kundvagnar',
  cartUpdated: 'Kundvagn Uppdaterad',
  cartUpdatedAndRemovedCount: 'Kundvagnen har uppdaterats; {count} artiklar som inte kan beställas har tagits bort',
  category: 'Kategori | Kategorier',
  categoryCreated: 'Kategori har skapats',
  categoryNotFoundError: '403: Enhetskategorin kan inte hittas',
  categoryUpdated: 'Kategori har uppdaterats',
  centimeter: 'Centimeter | Centimeter',
  changeNotification: 'Meddelande om förändring',
  changeScope: '{n} {type} påverkas',
  changeUserOrganization: 'Ändra organisation',
  chapter: 'Kapitel | Kapitel',
  chapterHeader: 'Kapitelrubrik',
  chaptersOnly: 'Endast kapitel',
  charLimitHelpText: 'Ange mellan {min} och {max} tecken',
  chineseDescription: 'Beskrivning på kinesiska',
  chineseName: 'Kinesiskt Namn',
  circle: 'Cirkel',
  city: 'Ort',
  className: 'Namn på klass',
  classicAdminMessage: 'Detta tar dig tillbaka till Flex för användning av adminmoduler.',
  classicAdmins: 'Klassiska admin',
  classicExporter: 'Klassisk exportör',
  classicExporterMessage: 'Äldre versionens Flash-baserade modul för innehållsexport',
  classicOrganizationAdmin: 'Klassisk organisationsadmin',
  classicOrganizationAdminMessage: 'Äldre versionens Flash-baserade modul för användaradministration och hantering av organisationer och användare',
  classicPublisher: 'Klassisk publicerare',
  classicPublisherMessage: 'Äldre versionens Flash-baserade publiceringsmodul för innehållsskapande och utskriftsinställningar',
  classicReporting: 'Klassisk rapportering',
  classicReportingMessage: 'Äldre versionens Flash-baserade rapporteringsmodul',
  classicTenantAdmin: 'Klassisk innehavaradmin',
  classicTenantAdminMessage: 'Äldre versionens Flash-baserade administrationsmodul för innehavarinställningar',
  clear: 'Rensa',
  clearFilters: 'Rensa filter',
  clearHotpoints: 'Rensa hotpoints',
  clearItemNumber: 'Rensa artikelnummer',
  clearItemNumberMessage: 'Följande data raderas om artikelnumret tas bort:',
  clearItemNumberTitle: 'Vill du rensa artikelnumret?',
  clearSearch: 'Rensa Sökfältet',
  clickAction: 'Klicka på åtgärd',
  clickHereToUpload: 'Släpp fil eller klicka för att ladda upp en åsidosättning.',
  clickMagnifyingGlass: 'Klicka på förstoringsglaset för att gå direkt till den avancerade sökningen.',
  clickOkToContinue: 'Klicka på "OK" för att fortsätta.',
  clickToDownload: 'Klicka för att ladda ned',
  clickToEnlarge: 'Klicka för att förstora',
  clickToOpen: 'Klicka för att öppna',
  clipboard: 'Urklipp',
  clipboardAccessError: 'Vänligen justera inställningarna i din webbläsare för att tillåta tillgång till Urklipp',
  close: 'Stäng',
  closed: 'Stängd',
  collapseAll: 'Dölj allt',
  color: 'Färg | Färger',
  column: 'Kolumn | Kolumner',
  columnItemType: {
    customText: 'Anpassa text',
    documentTitle: 'Dokumenttitel',
    horizontalLine: 'Horisontell linje',
    pageName: 'Sidnamn',
    pageNumber: 'Sidnummer',
    printDate: 'Utskriftsdatum',
    tenantName: 'Klientnamn',
    userName: 'Användarnamn'
  },
  columnMapping: 'Mappa kolumner',
  columnName: 'Namn på kolumn',
  combinedPage: 'Kombinerad sida',
  combinedPageMessage: 'Diagram överst, artikellista nederst',
  comingSoon: 'Kommer snart',
  commaDelimited: 'Kommaavgränsad',
  comment: 'Kommentar | Kommentarer',
  commentAdded: 'Kommentar tillagd',
  commentCannotBeEmpty: 'Fältet får inte vara tomt',
  commentDeleted: 'Kommentar borttagen',
  commentEdit: 'Lägg till/redigera kommentarer',
  commentEditAll: 'Redigera alla kommentarer',
  commentUpdated: 'Kommentar uppdaterad',
  commentView: 'Visa kommentarer',
  commerceSystem: 'Handelssystem',
  completed: 'Slutfört',
  configuration: 'Konfiguration | Konfigurationer',
  confirm: 'Bekräfta',
  confirmBrowseFlowApplyToChildren: 'Vill du tillämpa detta flöde på underordnade organisationer?',
  confirmBrowseFlowOverrideToChildren: 'Detta tar bort alla åsidosättningar av flöden som ställts in för de underordnade organisationerna.',
  confirmPrintSettingsApplyToChildren: 'Vill du tillämpa denna utskriftsinställning på underordnade organisationer?',
  confirmPrintSettingsOverrideToChildren: 'Detta tar bort alla åsidosättningar av utskriftsinställningar som ställts in för de underordnade organisationerna.',
  contains: 'Innehåller',
  containsHeaderRow: 'Innehåller Rad med Rubrik',
  content: 'Innehåll | Innehåll',
  contentAccessControls: 'Åtkomstkontroller för {content}',
  contentEntity: 'Innehållsenhet | Innehållsenheter',
  contentNotFound: 'Innehåll hittades inte',
  contentUpdatedQueueJob: 'Kö för Uppdaterat innehåll',
  contentViewerMoreInfo: 'Mer information',
  contourShape: 'KonturForm',
  convertEntity: 'Konvertera {entity}',
  convertToEntity: 'Konvertera till {entity}',
  copiedPartNumber: 'Kopierat artikelnummer {partNumber}',
  copy: 'Kopiera',
  copyAccessControls: 'Kopiera åtkomstkontroller',
  copyAccessControlsWarning: 'Detta kopierar alla tilldelade åtkomstkontroller från en vald organisation till denna aktuella organisation',
  copyAndRetain: 'Kopiera & Spara för Användning vid Integrering',
  copyAndRetainWidget: 'Kopiera och behåll, det här är den enda gången som värdet för widget-tillstånd visas för dig i applikationen',
  copyAtoB: 'Kopiera {a} till {b}',
  copyBranches: 'Kopiera grenar',
  copyBranchesMessage: 'Kopiera valda grenar från källflödet till ett målflöde.',
  copyContent: 'Kopiera {type}? {name}',
  copyItem: 'Kopiera {item}',
  copyItemQuestion: 'Kopiera {item}?',
  copyMeMessage: 'Skicka en kopia av det här meddelandet till mig',
  copyPartNumberToClipboard: 'Kopiera {label} till urklipp',
  copyProduct: 'Kopiera produkt',
  copyTo: 'Kopiera till {target}',
  copyingItem: 'Kopierar {item}',
  copyrightMessage: '© 2010-{year} Documoto Inc. Alla rättigheter förbehållna.',
  count: 'Antal',
  country: 'Land | Länder',
  coverAmpStitchPages: 'Täck och sammanfoga sidor',
  coverPages: 'Omslagssidor',
  createAssembly: 'Skapa sammansättning',
  createNewProductPage: 'Skapa ny produktsida',
  created: 'Skapad',
  createdBy: 'Skapad av {name}',
  createdDate: 'Skapad den',
  createdOn: 'Skapad den',
  currentPassword: 'Nuvarande lösenord',
  custom: 'Specialtillverkad',
  czechDescription: 'Beskrivning på tjeckiska',
  czechName: 'Tjeckiskt Namn',
  dashboard: 'Instrumentpanel | Instrumentpaneler',
  dashboardLibrary: 'Kontrollpanelens Bibliotek',
  dataInsights: 'Data-Insikter',
  dataInsightsInfoMessage: 'Center för Rapportering och Kontrollpanelen för insikter om innehåll, användare och data.',
  dataMapping: 'Kartläggning av data/stickprov (upp till tio rader)',
  dataOptions: 'Val för data',
  date: 'Datum',
  dateModified: 'Datum ändrat',
  debugPageBuilderPLZ: 'Felsök Page Builder PLZ',
  december: 'December',
  decreaseHotpoint: 'Minska Hotpoint',
  'default': 'Standardvärde',
  defaultAddress: 'Standardadress',
  defaultBrowseFlow: 'Standardflöde',
  defaultCurrencyCode: 'Standardvalutakod',
  defaultCurrencySymbolOn: 'Standard valutasymbol på',
  defaultEmailRecipient: 'Standardmottagare av e-post | Standardmottagare av e-post',
  defaultImage: 'Standardbild | Standardbilder',
  defaultImagesManager: 'Standardbildhanterare',
  defaultItemImage: '{item} standardbild',
  defaultPartsListLayout: 'Använd standardlayout för artikellista',
  defaultPartsListLayoutHelp: 'Standard artikellayout till vänster eller under illustrationen',
  defaultSearchMode: 'Standardsökläge',
  defaultSearchModeHelp: 'Ställ in global sökmetod till \'innehåller\' eller \'exakt\'',
  defaultSortMode: 'Standardsorteringsläge',
  defaultSupplier: 'Standardleverantör',
  defaultTocStateOpen: 'Innehållsförteckning öppnas som standard',
  defaultTocStateOpenHelp: 'Anger om innehållsförteckningen ska öppnas automatiskt när en bok visas',
  defaultUom: 'Standardenhet för mått',
  defaultValue: 'Standardvärde',
  defaultView: 'Standardvy',
  defaults: 'Standardvärden',
  defaultsAndCapabilities: 'Standardvärden och funktioner',
  'delete': 'Ta bort',
  deleteAll: 'Ärv från överordnad',
  deleteAnyPartnerApiKeys: 'Radera alla API-nycklar från partners som tillhandahölls för SmartEquip.',
  deleteContent: 'Vill du ta bort {type}? {name}',
  deleteFilesMessage: 'Vill du ta bort {count} fil(er)?',
  deleteHotpointLinksTitle: 'Är du säker på att du vill radera länk(ar) till höjdpunkter?',
  deleteMessage: 'Vill du ta bort?',
  deletePart: {
    affectedCarts: 'Delen kommer att raderas permanent från alla kundvagnar som innehåller denna del.',
    deletingPartNumber: '{partNumber} kommer att raderas.',
    infoOne: 'Delar kommer att tas bort omedelbart i administration av bibliotek och innehåll. Den borttagna delen kommer att vara sökbar tills en ny registrering har skett inom ett par minuter.',
    infoTwo: 'Denna åtgärd kan inte ångras utan hjälp från Documoto Support. Efter 90 dagar kommer den borttagna uppgiften och allt som är kopplat till den att raderas permanent.'
  },
  deletePartCollectionConfirmMsg: 'Är du säker på att du vill ta bort det här {partCollection} från {productPage}?',
  deletePartInUse: {
    body: 'Documoto tillåter i nuläget endast radering av delar som inte tillhör sidor. Vänligen avlägsna denna del från alla publicerade sidor eller utkast för att fortsätta med radering.',
    submitLabel: 'Gå till sida där denna används',
    title: 'Denna del tillhör en sida eller sidor och kan inte raderas.'
  },
  deleteProductPage: {
    deletingIdentifier: '{identifier} kommer att raderas.',
    infoOne: 'Produktsidor som raderas tas bort omedelbart i bibliotek och innehåll. Den raderade produktsidan kommer att vara sökbar tills indexeringen har skett inom några minuter.',
    infoTwo: 'Denna åtgärd kan inte ångras utan hjälp från Documoto Support. Efter 90 dagar raderas den borttagna filen och alla länkar permanent.'
  },
  deleteRelated: 'Är du säker på att du vill ta bort {count} {type}?',
  deleteSelectedCriteria: 'Ta bort valda kriterier',
  deleteTagsTitle: 'Är du säker på att du vill radera tagg(ar)?',
  deleteTaxonMessage: 'Detta tar bort denna taxonomi permanent tillsammans med alla underordnade objekt. Vill du fortsätta?',
  deleteTaxonomyMessage: 'Detta tar bort alla taxonomier permanent för denna organisation eller innehavare. Vill du fortsätta?',
  deleteTenantSupplier: 'Är du säker på att du vill ta bort denna leverantör för hyresgästen?',
  deletedItem: '{item} raderad',
  demo: 'Demo',
  description: 'Beskrivning',
  deselectAll: 'Avmarkera alla',
  deselectCriteria: 'Avmarkera kriterier',
  detail: 'Detalj | Detaljer',
  diagonal: 'Diagonal',
  diameter: 'Diameter',
  disable: 'Inaktivera',
  disableAll: 'Inaktivera alla',
  disableDocumotoTenant: 'Inaktivera Documoto Tenant',
  disableFwdReindex: 'Inaktivera vidarebefordran av återindexerad media för DSW',
  disableLibraryBannerImage: 'Inaktivera bild för bibliotekets annonsruta',
  disableSmartEquipModalTitle: 'Är du säker på att du vill inaktivera denna licens?',
  disableTEK: 'Inaktivera Inloggning Direkt från URL',
  disableUserLogin: 'Inaktivera inloggning med användarnamn/lösenord',
  disableUserLoginErrorMessage: 'Din organisation kräver SSO-autentisering. Inloggning med användarnamn/lösenord är inte tillåtet för din användargrupp. Vänligen logga in med SSO.',
  disableUserLoginTooltip: 'För att aktivera detta krävs en fungerande SSO-konfiguration. Om SSO inte är inställt kommer berörda användare att förlora åtkomsten till Documoto.',
  disabled: 'Inaktiverat',
  discard: 'Ignorera',
  discardChanges: 'Ignorera ändringar',
  discardQ: 'Ignorera ändringar?',
  discountPrice: 'Rabatterat Pris',
  discounted: 'Rabatterat',
  discountedPrice: 'Rabatterat pris',
  discountedTotal: 'Summa efter rabatt',
  displayInOrdersList: 'Visa i Lista med Beställningar',
  displayLocation: 'Visningsplats',
  displayOrder: 'Visningsordning',
  displayOrderDescription: 'Ställer in visningsordning för rullgardinsmenyn Filter för innehållstyptaggar',
  displaySupplierPartInfo: 'Visa leverantör i artikelinformation',
  document: 'Dokument | Dokument',
  documentLabel: 'Dokument | Dokument',
  documentSettings: 'Inställningar för dokument',
  documotoAcademy: 'Documoto Academy',
  documotoLicensePackage: 'Licenspaket för Documoto',
  domain: 'Domän',
  domainEmptyMessage: 'Tillåten domän får inte vara tom',
  domainInvalidMessage: 'Ett giltigt domännamn krävs',
  download: 'Ladda ned',
  downloadBrowser: 'Ladda ned en av dessa utmärkta webbläsare.',
  downloadFailed: 'Fel vid nedladdning {name}',
  downloadStarted: 'Nedladdning pågår för {name}',
  draft: 'Utkast | Utkast',
  draftBomDeleteTitle: 'Är du säker på att du vill radera denna denna del av sidan?',
  draftBomDropError: 'Det går inte att nästla delar som är djupare än 5 nivåer',
  draftBomEmptyField: 'Alla fält i Listan med Delar måste fyllas i',
  draftBomError: 'Fel vid manipulering av Materialförteckningens utkast',
  draftBomMultipleDeleteTitle: 'Är du säker på att du vill radera dessa delar av sidan?',
  draftBomQuantityError: 'Kvantitet måste vara ett nummer',
  draftPage: 'Utkast för Sida',
  draftPageDelete: 'Radera Utkast',
  draftPageDeleteMessage: 'Utkast för Sida har raderats.',
  draftPageDeleteWarning: 'Radering av Utkast för Sida kommer att avbryta pågående uppdateringar.',
  draftPageLastUpdated: 'Utkast - Senast Uppdaterat {date} av {username}',
  draftPageLoadError: 'Sidan med utkast kunde inte laddas.',
  draftPageProcessingPlz: 'Sidan laddas från PLZ-fil',
  draftPagePublishInProgress: 'Jobb för Publicering av Sidan pågår',
  draftPageSaveSuccess: 'Utkast för Sida har sparats.',
  draftPageSaveUnsuccessful: 'Misslyckades att spara Utkast för Sida.',
  draftSheetImageHotpointsFailure: 'Kunde inte generera {algorithm} hotpoints för bild av utkast.',
  draftValidationMessage: {
    empty: 'Inga Fel/Varningar vid Bekräftelse',
    hotpointOrHotpointLink: 'Artikel på Stycklista {item} saknar hotpoints/hotpoint-länkar',
    item: 'VARNING: Del nummer {partNumber} i materialförteckningen har inget angivet artikelnummer',
    quantity: 'Artikel på Stycklista {item} saknar angiven kvantitet',
    supersede: 'Delen {partNumber} har ersatt delen {supersededPartNumber}.',
    tag: 'Artikel på Stycklista {item} etikett {tagName} saknar värde för etikett',
    translationDescription: 'Artikel på Stycklista {item} saknar {lang} beskrivning av översättning',
    uom: 'Artikel på Stycklista {item} saknar angiven måttenhet'
  },
  drawAutohotpointRegion: 'Rita {shape} i storlek',
  drawMinimumArea: 'Rita minsta område',
  dropFileMessage: 'Släpp fil här eller klicka för att ladda upp.',
  duplicate: 'Duplicera',
  duplicateSaveError: 'Dubbel artikel. Kan inte spara.',
  dutchDescription: 'Beskrivning på holländska',
  dutchName: 'Holländskt Namn',
  dynamic: 'Dynamisk',
  dynamicNaming: 'Dynamisk namngivning',
  ecommerce: 'e-handel',
  ecommerceEmailFormatCreated: 'ECommerce mejlformat har skapats',
  ecommerceEmailFormatSaved: 'ECommerce mejlformat har sparats',
  ecommerceLogo: 'Logotyp för e-handel',
  ecommerceUseExtOrder: 'Använd externt beställningsnummer för e-handel',
  edit: 'Redigera',
  editItem: 'Redigera {item}',
  email: 'E-postadress',
  emailAsCsv: 'E-post som CSV (obligatoriskt format för import)',
  emailAsXlsx: 'E-post som XLSX',
  emailBasicPartInfo: 'Viktig information om e-post',
  emailComments: 'Kommentarer via e-post',
  emailDetails: 'E-postadress',
  emailDisplayedCartColumns: 'E-post som visas i varukorgen',
  emailFormat: 'Mejlformat',
  emailFormatTemplate: 'Mall för mejlformat | Mallar för mejlformat ',
  emailList: 'Mejlinglista',
  emailMessage: 'En e-postadress krävs',
  emailRecipient: 'E-postmottagare | E-postmottagare',
  emailRecipientMessage: 'Dessa e-postadresser får ett e-postmeddelande när beställningsstatus ändras till',
  emailSubject: 'Ämne',
  emptyBomState: 'Inga BOM-Artiklar har angivits för sidan. Klicka på +{add} för att starta',
  emptyMessage: {
    orderSuggestions: 'Det ser inte ut att finnas några beställningsförslag för denna artikel.'
  },
  enable: 'Aktivera',
  enable3d: 'Aktivera 3D',
  enable3dIllustrations: 'Aktivera 3D-illustrationer',
  enable3dThumbnails: 'Aktivera 3D-miniatyrer',
  enableAPIKeyAdmin: 'Aktivera administratör för API-Nycklar',
  enableAll: 'Aktivera alla',
  enableCommerce: 'Aktivera handel',
  enableEcommerceOrderManagement: 'Aktivera beställningshantering',
  enableExportToLinkOne: 'Aktivera export till LinkOne',
  enableExportToSmartEquip: 'Aktivera export till SmartEquip',
  enableExporter: 'Aktivera exportör',
  enableIframeSupport: 'Aktivera stöd för iFrame',
  enableKnowledgeBase: 'Aktivera AI-driven sökning',
  enableLibraryBetaFeatures: 'Aktivera bibliotekets betafunktioner',
  enableMediaCategorySearch: 'Aktivera gruppering efter mediekategorier i kontextuell sökning',
  enablePDFDownloadWarning: 'Aktivera varning för nedladdning av stor PDF',
  enablePLZToDraft: 'Aktivera PLZ-process för utkast',
  enablePerformanceLogging: 'Aktivera prestandaloggning',
  enableQuickAddToCart: 'Aktivera Lägg till snabbt i kundvagnen',
  enableQuickAddToCartHelpContext: 'Att ställa in detta till ’Aktivera’ kommer att aktivera funktionen Lägg till snabbt i kundvagnen ovanför innehållsvyn.',
  enableRocketUi: 'Aktivera Rocket-användarupplevelse',
  enableSmartEquipApiIntegration: 'Aktivera integration med SmartEquip API',
  enableWidgetLogo: 'Aktivera logotyp för Documotos widget',
  enableWidgets: 'Aktivera widgetar',
  enabled: 'Aktiverad',
  encryptedKey: 'Krypterad nyckel',
  endDate: 'Slutdatum',
  endDateBad: 'Startdatum måste vara innan eller samtidigt som slutdatum.',
  enforceNumericSize: 'Genomdriv numerisk storlek',
  englishDescription: 'Beskrivning på engelska',
  englishName: 'Engelskt Namn',
  enterReportParameters: 'Ange RapportParametrar',
  enterUniqueNameForNewItem: 'Ange ett unikt namn för den nya {item}',
  enterValidEmail: 'Ange en giltig e-postadress',
  enterValidNumber: 'Ange ett giltigt nummer.',
  enterprise: 'Företag',
  entityType: 'Enhetstyp | Enhetstyper',
  erp: 'ERP',
  erpEndpointConfig: 'ERP-konfigurering för slutpunkt',
  erpPartInfo: 'Varaktighet i minuter för ERP-delens informationscache',
  erpSystem: 'ERP-system',
  erpSystemSaved: 'ERP-system har sparats',
  erpSystems: 'ERP-system',
  error: 'Fel',
  errorDeletePageMessage: 'Ett fel inträffade när sidan raderades.',
  errorInputParsing: 'Problem vid analys av ingående fil.',
  errorPageMessage: 'Ett fel har uppstått.',
  errorPageTitle: 'Något gick snett här ...',
  errorType: {
    error: 'Fel',
    warning: 'Varning'
  },
  essential: 'Väsentlig | Väsentligheter',
  eta: 'Beräknad leveranstid',
  etlJob: 'ETL',
  exact: 'Exakt',
  excelFile: 'Excel-Fil',
  existing: 'Befintliga',
  expandAll: 'Visa allt',
  'export': 'Exportera',
  exportAsCSVDropdown: 'Exportera som CSV',
  exportAsCsv: 'Exportera som CSV (obligatoriskt format för import)',
  exportAsHtml: 'Exportera som HTML',
  exportAsPdf: 'Exportera som PDF',
  exportAsPlz: 'Exportera som PLZ',
  exportAsXlsx: 'Exportera som XLSX',
  exportBasicPartInfo: 'Exportera grundläggande information om artikeln',
  exportCartToXlsxDisabled: 'Inaktivera Exportera kundvagn till XLSX',
  exportCartToXlsxEnabled: 'Aktivera Exportera kundvagn till XLSX',
  exportDisplayedCartColumns: 'Exportera visade kundvagnskolumner',
  exportJob: 'Exportera jobb',
  exportLane: 'Exportbana',
  exportMessage: 'Exportjobb har skickats in.',
  exportParts: 'Exportera Delar',
  exportPartsXlsx: 'Exportera delar till xlsx',
  exportSearch: 'Exportera sökning',
  exporter: 'Exportör',
  exporterMessage: 'Möjliggör export av innehåll',
  external: 'Extern | Externa',
  externalUrl: 'Extern URL',
  faceted: 'Fasetterad',
  facetedTag: 'Filtervärden bör vara fasetterade',
  facetedTagTooMany: 'Taggen överskrider gränsen på 1 000 unika taggvärden',
  failedAction: 'Det gick inte att {action} {content}.',
  failedProcessContentSql: 'Bearbeta Innehåll misslyckades på grund av otillåten text. Vänligen ladda upp innehåll som stöds igen.',
  failedToCopy: 'Det gick inte att kopiera {content}.',
  failedToDelete: 'Det gick inte att ta bort {content}.',
  failedToLoad: 'Det gick inte att läsa in {content}.',
  failedToSave: 'Det gick inte att spara {content}.',
  failedToSubmitFeedback: 'Kunde inte skicka feedback.',
  failedToSubmitItem: 'Misslyckades att skicka {item}',
  failedToUpdate: 'Det gick inte att uppdatera {content}.',
  'false': 'Falsk',
  faq: 'Vanliga frågor',
  favorites: 'Favoriter',
  favoritesLists: 'Lista med favoriter',
  february: 'Februari',
  feedbackForm: 'Skicka feedback',
  feedbackFormMessage: 'Ge synpunkter på funktioner du skulle vilja ha',
  field: 'Fält | Fält',
  fieldDefinition: 'Definiering av Fält',
  fieldName: 'Fältets namn',
  file: 'Fil | Filer',
  fileUpload: 'Filuppladdning',
  filename: 'Filnamn',
  filesSubmitted: 'Fil(er) skickade för bearbetning',
  fill: 'Fyll',
  filter: 'Filter | Filter',
  filterBoundsError: 'Filtret måste innehålla 3 eller fler tecken',
  filterBy: 'Filtrera efter',
  filterOrgNameOnly: 'Filter: Endast Namn på Org',
  filterOrgParentNames: 'Filter: Namn på Org & Överordnad Org',
  filterable: 'Kan filtreras',
  filterableTag: 'Filtrerbar tagg',
  finnishDescription: 'Beskrivning på finska',
  finnishName: 'Finskt Namn',
  firstName: 'Förnamn',
  firstNameEmpty: 'Förnamn kan inte vara tomt.',
  fixedHotpointSize: 'Fast hotpoint-storlek',
  font: 'Teckensnitt | Teckensnitt',
  footer: 'Sidfot',
  forSearchTerm: 'för {term}',
  forgotPassword: 'Glömt lösenordet',
  forgotPasswordMessage: 'Ett mejl med instruktioner om hur du återställer ditt lösenord skickas till det angivna användarnamnet.',
  forgotPasswordSuccess: 'Om det angivna användarnamnet är giltigt så skickas ett mejl med instruktioner om hur du återställer ditt lösenord till den sparade adressen.',
  form: 'Formulär | Formulär',
  formCount: 'Antal Formulär',
  formName: 'Formulärets namn',
  formType: 'Typ av formulär',
  format: 'Format',
  formattingOptions: 'Formateringsalternativ',
  freezeImage: 'Frys bild',
  frenchDescription: 'Beskrivning på franska',
  frenchName: 'Franskt Namn',
  fri: 'Fre',
  from: 'Från',
  fromDate: 'Från datum',
  frontCover: 'Främre pärm',
  frontStitch: 'Främre häftning',
  fullScreen: 'Helskärm',
  gdprFaqs: 'Vanliga frågor och svar om GDPR',
  gdprMessage: 'Genom att logga in på den här sektionen av vår webbplats så förstår du att vi använder nödvändiga kakor. Dessa kakor är väsentliga för att du ska kunna navigera bland våra tjänster. Utan dessa kakor kan vi inte tillhandahålla de tjänster du har efterfrågat. För ytterligare information, se vår {policy}.',
  general: 'Allmänt',
  generalSearch: 'Allmän sökning',
  generalSearchCriteriaAlreadySet: 'Sökkriteriet "Allmän sökning" har redan ställts in.',
  generic: 'Generiskt',
  germanDescription: 'Beskrivning på tyska',
  germanName: 'Tyskt Namn',
  goTo: 'Gå till',
  goToHome: 'Gå till Start',
  goToJobManager: 'Gå till Jobbhanteraren',
  goToPartCollections: 'Gå till {partCollections}',
  goToSearch: 'Gå till Sök',
  gotIt: 'Jag förstår',
  hashKey: 'Hash-nyckel',
  header: 'Rubrik',
  headerAmpFooter: 'Sidhuvud och sidfot',
  help: 'Hjälp',
  helpCenter: 'Hjälpcenter',
  hideBookInSearchAndRecent: 'Dölj böcker i sökresultat och nyligen tillagda',
  hideDuplicatePages: 'Dölj dubblettsidor',
  hidePageInSearchAndRecent: 'Dölj sidor i sökresultat och nyligen tillagda',
  hidePartInSearchAndRecent: 'Dölj artiklar i sökresultat och nyligen tillagda',
  highlightDescription: 'Markera artiklar i artikellistan med denna tagg',
  history: 'Historik',
  home: 'Hem',
  homePageSettings: 'Inställningar för startsida',
  homepageOnly: 'Endast hemsidan',
  horizontal: 'Vågrät',
  host: 'Värd',
  hotpoint: 'Hotpoint | Hotpoints',
  hotpointCalloutBehavior: 'Beteende för Hotpoint Callout',
  hotpointLink: 'Länk till Höjdpunkt | Länkar till Höjdpunkter',
  hotpointLinksWillBeCreated: 'Hotpoint-länkar skapas i {count} {content}',
  hotpointShift: 'Hotpoint (Skift H)',
  hotpointZoomBehavior: 'Beteende för Hotpoint Zoom',
  hotpointsGenerated: '{count} hotpoints hittades på bilden.',
  hourlyDWSRequestLimit: 'Gräns per timme för DWS-begäran',
  hourlyRESTRequestLimit: 'Gräns per timme för REST-begäran',
  htmlUiUserSwitchEnabled: 'Växling av användare aktiverad för HTML UI',
  hungarianDescription: 'Beskrivning på ungerska',
  hungarianName: 'Ungerskt Namn',
  icon: 'Ikon',
  id: 'Id',
  identifier: 'Identifierare',
  identifierRequiredErrorMessage: 'Du måste ange en kod',
  ignore: 'IGNORERA',
  ignoreAccessControls: 'Ignorera åtkomstkontroller',
  ignoreMatchingTranslations: 'Ignorera översättningar med samma platser vid import',
  illustration: 'Illustration | Illustrationer',
  image: 'Bild | Bilder',
  imageDeleteMessage: 'Är du säker på att du vill radera Bilden på denna Sida?',
  imageDimensionsExceededMessage: 'Den största storleken för bilder i Documoto är 65,5 megapixlar (8 191 X 8 191 pixlar).  Bilden som du försöker ladda upp har överskridit maximum och kan inte laddas. Klicka på "Ändra storlek" för att låta Documoto ändra bildens storlek och infoga den, eller "Avbryt" för att redigera bilden och infoga den manuellt',
  imageOptimizer: 'Bildoptimerare',
  imageSaveFail: 'Det gick inte att Spara bilden',
  imageSaveSuccess: 'Uppdatering av Bilder slutförd',
  imageSizeExceededMessage: 'Den största storleken på bildfiler i Documoto är {size} megabyte. Bilden som du försöker ladda upp har överskridit maximum och kan inte laddas. Vänligen ändra storlek på bilden som ska läggas till på denna sida.',
  imageSizeExceededTitle: 'Maximal Storlek för Bild har Överskridits',
  imageUploadFailure: 'Det gick inte att Ladda upp bilden',
  'import': 'Importera',
  importBOM: 'Importera stycklista',
  importBOMError: 'Det gick inte att bearbeta provdata, kontrollera ingångskällan igen',
  importName: 'Importnamn',
  importParts: 'Importera Delar',
  inCart: 'I kundvagnen',
  inCartDescription: 'Visa taggar i kundvagnen',
  inPartsList: 'I artikellistan',
  inPartsListDescription: 'Visa taggar i artikellistan',
  inch: 'Tum | Tum',
  includeComments: 'Inkludera kommentarer',
  includeCommentsAuthorAndDate: 'Inkludera kommentarens författare och datum',
  includeHeaderRow: 'Inkludera rad med rubrik',
  includeImages: 'Inkludera bilder',
  includeNewParts: 'Inkludera endast "nya" delar (inte i Documoto)',
  includePagePartDetails: 'Inkludera detaljer om delnivå på sidan',
  includePagesIndex: 'Inkludera sidindex',
  includePartDetails: 'Inkludera detaljer om delnivå',
  includePartsIndex: 'Inkludera artikelindex',
  includePartsList: 'Inkludera artikellista',
  includeSubChapters: 'Inkludera underkapitel',
  includeWatermark: 'Inkludera vattenstämpel?',
  increaseHotpoint: 'Öka Hotpoint',
  indefinitely: 'På obestämd tid',
  indexIncludeTimestamp: 'Index inkluderar tidsstämpel',
  indexLane: 'Indexbana',
  indexQueueJob: 'Indexeringskö',
  indexed: 'Indexerad',
  indexingConfiguration: 'Konfigurering av indexering',
  info: 'Info',
  information: 'Information',
  inherit: 'Ärv',
  inherited: 'Överförd',
  inheritedParent: 'Ärvd från överordnad.',
  inputSource: 'Ingångskälla',
  inputSpecification: 'Ange ingång',
  inputType: 'Inmatningstyp',
  inputTypeListboxWarning: 'Sorteringskonfigurationer visas när man sparar',
  insertDataField: 'Infoga datafält',
  integration: 'Integration | Integrationer',
  integrationsAddPartToErpCart: '{action} Lägg till artikel i ERP-kundvagn',
  integrationsAddToShoppingCartPricingFromErp: '{action} Lägg till i kundvagnens prissättning från ERP',
  integrationsDisableErp: 'Inaktivera ERP',
  integrationsDoErpForQuotes: 'Använd ERP för offerter',
  integrationsEnableErp: 'Aktivera ERP',
  integrationsEnableFetchPartInfoFromErp: 'Aktivera Hämta artikelinfo från ERP',
  integrationsEnableScopeErp: 'Aktivera {scope} ERP',
  integrationsEnableSendShoppingCartToErp: 'Aktivera Skicka kundvagn till ERP',
  integrationsEnableSyncPoAddressWithErp: 'Aktivera Synkronisera postadress med ERP',
  integrationsErpAvailabilityMappedFrom: 'ERP-tillgänglighet kartlagd från',
  integrationsErpCurrencyCodeMappedFrom: 'ERP-valutakod kartlagd från',
  integrationsErpDiscountedPriceMappedFrom: 'ERP-pris efter rabatt kartlagt från',
  integrationsErpEtaMappedFrom: 'ERP beräknad leveranstid kartlagd från',
  integrationsErpMappings: 'ERP-kartläggning',
  integrationsErpRetailPriceMappedFrom: 'ERP-detaljhandelspris kartlagt från',
  integrationsErpWholesalePriceMappedFrom: 'ERP-grossistpris kartlagt från',
  integrationsInvokeGetPartInfoFromClient: 'Anropa HämtaArtikelInfo från klient',
  integrationsParseAddressForType: 'Tolka adress för typ',
  integrationsShoppingCartAndPartsTitle: 'Kundvagn och artiklar',
  integrationsShoppingCartAvailability: '{action} Kundvagnstillgänglighet',
  integrationsShoppingCartEtaFromErp: '{action} Beräknad leveranstid för kundvagnen från ERP',
  internalApiKey: 'Intern API-Nyckel',
  internalDescription: 'Intern beskrivning',
  internalName: 'Internt namn',
  internalNameOptional: 'Din identifierare för taggen',
  internalNameRequired: 'Ett namn krävs',
  invalidDecimals: 'Endast två decimaler är tillåtna',
  invalidField: '{field} är ogiltigt',
  invalidFileType: 'Filtypen stöds inte. Se en fullständig lista över filnamnstillägg som stöds i Documoto Support Center.',
  isSearchable: 'Är sökbar',
  isSystem: 'Är system',
  italianDescription: 'Beskrivning på italienska',
  italianName: 'Italienskt Namn',
  item: '#',
  itemAlt: 'Artikel',
  itemCopied: '{item} kopierat',
  itemDeleted: '{item} borttaget',
  itemDetails: 'Produktinformation',
  itemInProgress: '{item} pågår',
  itemInformation: 'Information om {item}',
  itemMustBeLteItem: '{itemA} måste vara lika med eller innan {itemB}.',
  itemMustBeUnique: '{item} måste vara unik',
  itemMustBeUniqueAndNotEmpty: '{item} måste vara unik och är obligatorisk',
  itemName: '{item} Namn',
  itemSaved: '{item} har sparats',
  itemSpecification: 'Artikelspecifikation',
  january: 'Januari',
  japaneseDescription: 'Beskrivning på japanska',
  japaneseName: 'Japanskt Namn',
  job: 'Jobb | Jobb',
  jobManager: 'Jobbhanterare',
  jobManagerMessage: 'Exportera, publicera och skriv ut/ladda ned jobb',
  july: 'Juli',
  june: 'Juni',
  knowledgeBase: {
    config: {
      fetchUsage: 'Användning av hämtningsfunktion',
      maxTokensDefault: 'Standard max. token per månad',
      maxTokensOverride: 'Max. token per månad har åsidosatts',
      noData: 'Inga konfigurationsdata tillgängliga.'
    },
    errors: {
      maxFileSizeExceeded: 'Filen överskrider den maximala filstorleken för kunskapsbasen.',
      maxTokensExceeded: 'Du har nått gränsen för max. token.',
      pageNavigationFailed: 'Kunde inte navigera till sidan.'
    },
    feedback: {
      prompt: 'Tack för att du meddelade oss. Vad var det för fel med detta svar?',
      reasons: {
        hardToUnderstand: 'Svårt att förstå',
        incorrect: 'Felaktigt',
        missingInfo: 'Information saknas',
        offTopic: 'Avvek från ämnet'
      },
      submitted: 'Din feedback har skickats.'
    },
    library: {
      buttonText: 'Fråga AI',
      disclaimer: 'Documoto AI kan göra misstag. Kontrollera att svaren är korrekta.',
      inputPlaceholder: 'Ställ en fråga...',
      noContent: 'Ingen kontext tillgänglig för detta dokument.',
      promptDefault: 'Frågorna besvaras endast från detta dokument. Ställ en fråga åt gången.',
      reference: 'PDF-referens',
      serviceError: 'Fel vid skapandet av kontext.',
      title: 'AI-driven sökning'
    },
    tenantKnowledgeBase: 'Hyresgästens kunskapsbas',
    usage: {
      inputTokens: 'Totalt inmatade token',
      noData: 'Inga användningsdata tillgängliga.',
      outputTokens: 'Totalt utmatade token',
      title: 'Token för sammanfattning av användning',
      totalTokens: 'Totalt använda token'
    }
  },
  koreanDescription: 'Beskrivning på koreanska',
  koreanName: 'Koreanskt Namn',
  label: 'Etikett | Etiketter',
  labelKey: 'Etikettnyckel',
  landscape: 'Liggande',
  laneConfiguration: 'Konfigurering av bana',
  language: 'Språk',
  largePDFDownloadWarning: 'På grund av PDF-filens storlek så kan det ta längre tid än vanligt att ladda och visa dokumentet i applikationen – vänligen vänta medan filen laddas ned för att visas.',
  lastGenerated: 'Senast Återskapad',
  lastModifiedDate: 'Senast ändrad den',
  lastName: 'Efternamn',
  lastNameEmpty: 'Efternamnet kan inte vara tomt',
  lastUpdatedOn: 'Senast uppdaterat den',
  layout: 'Layout',
  layoutOptions: 'Layoutalternativ',
  ledger: 'Register',
  left: 'Vänster',
  legal: 'Juridisk information',
  letter: 'Brev',
  library: 'Bibliotek',
  libraryAdmin: 'Biblioteksadmin',
  libraryBannerLogo: 'Webbannons för biblioteks logotyp',
  librarySettings: 'Biblioteksinställningar',
  librarySettingsDescription: 'Dessa inställningar styr olika biblioteksdelar och alternativ. Var försiktig när du utför ändringar. Kontakta Documoto-tjänster för mer information.',
  licenseConfiguration: 'Konfigurering av licenser',
  line: 'Rad',
  lineTool: 'Linjeverktyg',
  link: 'Länk | Länkar',
  listBox: 'Listruta',
  listBoxValue: 'Värde för Listruta | Värden för Listrutor',
  listValue: 'Värde för Lista | Värden för Listor',
  load: 'Ladda',
  loadMore: 'Läs in fler',
  loading: 'Läser in',
  loadingParts: 'Laddar komponenter',
  locale: 'Nationella inställningar',
  logiReportName: 'Namn på Rapport för Logi',
  logiReportToggle: 'Rapport för Logi?',
  login: 'Inloggning',
  loginBackground: 'Inloggningsbakgrund',
  loginGDPRMessageBeginning: 'Denna webbplats använder kakor. Genom att fortsätta använda webbplatsen samtycker du till användningen av kakor. För ytterligare information, se vår ',
  loginGDPRMessageEnd: 'och vår',
  loginSSO: 'Logga in med enkel inloggning',
  logo: 'Logotyp | Logotyper',
  logout: 'Logga ut',
  lookupLoadParts: 'Sök/Ladda Delar från Documoto vid Import',
  lowerBound: 'Nedre gräns',
  mOfNShown: '{m} av {n} visade',
  mToM: 'M2M',
  mainInfo: 'Huvudinfo',
  mainLogo: 'Huvudlogotyp',
  makePagesDivisibleBy: 'Gör sidorna delbara med:',
  manageItem: 'Hantera {item}',
  management: 'Hantering',
  manuallyResetPassword: 'Återställ lösenord manuellt',
  manuallySetPassword: 'Ställ in lösenord manuellt',
  march: 'Mars',
  margin: 'Marginal | Marginaler',
  markdown: 'Prissänkning',
  maxCharHelpMessage: 'Ange ett värde mellan {min} och {max} tecken som maximal teckenlängd.',
  maxCharacters: 'Maximalt antal tecken',
  may: 'Maj',
  media: 'Medium | Medier',
  mediaBookDeleteMessage: 'Om du raderar detta medium tas åtkomst till detta innehåll bort i både Biblioteket och Innehållsadmin och kommer inte längre vara tillgängligt för användare eller innehållsadministratörer. Artiklar och sidor i denna bok som inte finns i andra böcker kommer inte heller vara tillgängliga i Biblioteket.',
  mediaCategory: 'Mediekategori | Mediekategorier',
  mediaCategoryEditor: 'Redigerare för mediekategori',
  mediaCategoryName: 'Namn på mediekategori',
  mediaCategoryNameMissing: 'Alla mediekategorier måste ha ett namn',
  mediaDeleteMessage: 'Om du tar bort denna mall tas den bort från Innehållsadmin och kommer inte längre vara tillgänglig för kopiering till nytt medium.',
  mediaDeleteSuccessText: 'Den tas bort från listor när indexering har slutförts.',
  mediaDescription: 'Beskrivning av media',
  mediaIdentifier: 'Identifierare för media',
  mediaIdentifierDescription: 'Det interna mediumnummer som slutanvändare kan söka',
  mediaName: 'Namn på media',
  mediaPrintSettingsSaveSuccess: 'Utskriftsinställningar för medier har sparats',
  mediaWhereUsed: 'Medier där detta används',
  menu: 'Meny',
  merge: 'Slå samman',
  mergeOrOverrideMessage: 'Vill du skriva över eller slå samman de här objekten?',
  mergeWarning: 'Import av data kommer att uppdatera befintliga delar och lägga till nya poster',
  message: 'Meddelande',
  messageLevel: 'Meddelandenivå',
  messageMessage: 'Ett meddelande krävs',
  metadata: 'Metadata',
  microsite: 'Mikrosajt | Mikrosajter',
  micrositeAdmin: {
    cardSubtitle: 'Filen med det komprimerade innehållet och HTML-information',
    cardTitle: 'Sidans innehåll',
    errorRequiredFile: 'Kräver en zip-fil med sidans innehåll',
    fieldFile: 'Zip-fil med sidans innehåll',
    fieldPoint: 'Start för HTML'
  },
  minArea: 'Minsta Område',
  minAreaMessage: 'Lägsta värde krävs. Värdet får inte överskrida omfånget 1 till 1 500.  Måste vara ett siffervärde.',
  minCharacters: 'Minsta antal tecken',
  minMaxCharHelpMessage: 'Ange ett värde mellan {min} och {max} tecken för minsta och högsta antal tillåtna tecken. Maxvärdet måste vara större än eller lika med minimivärdet.',
  mine: 'Min',
  miscellaneous: 'Diverse',
  mon: 'Mån',
  month: 'Månad',
  moreInfo: 'Ytterligare information',
  multipleAlternatingPages: 'Flera alternerande sidor',
  multipleAlternatingPagesMessage: 'Diagram på sida 1 och 3, artikellista på sida 2 och 4.',
  multiplePages: 'Flera sidor',
  multiplePagesMessage: 'Diagram på sin egen sida följt av sidorna med artikellistan',
  myCart: 'Min kundvagn | Mina kundvagnar',
  nItemsCreated: '{n} {items} har skapats',
  nItemsDeleted: '{n} {items} har tagits bort',
  nOfMItems: '{n} av {m} {items}',
  name: 'Namn',
  nameDescriptionHelpText: 'Namnet och valfri beskrivning',
  navigation: 'Navigering',
  'new': 'Ny',
  newAPIKey: 'Ny API-Nyckel',
  newERPSystem: 'Nytt ERP-system',
  newItem: 'Ny {item}',
  newKeyGenerated: 'Ny Nyckel för Integrering har Skapats, Kopiera & Spara för framtida bruk',
  newMediaCategory: 'Ny mediekategori',
  newPassword: 'Nytt lösenord',
  newTenant: 'Ny hyresgäst',
  newWidgetKey: 'Ny widget-nyckel',
  newWidgetKeyGenerated: 'Ny widget-nyckel har skapats, kopiera och behåll för framtida bruk',
  newsItem: 'Nyhet | Nyheter',
  noAPIKeys: 'Inga API-Nycklar har angivits.',
  noData: 'Inga Data',
  noFileSelected: 'Ingen fil har valts',
  noFilesSelected: 'Inga filer har valts',
  noFormsMessage: 'Inga Formulär har fastställts.',
  noIllustrationFound: 'Inga Illustrationer Hittades',
  noImageFound: 'Ingen Bild Hittades',
  noItemAddedToTarget: 'Ingen {item} har lagts till i {target}. ',
  noItemAvailable: 'Ingen {item} tillgänglig',
  noItemFound: 'Ingen {item} hittades.',
  noItemSelected: 'Ingen {item} vald',
  noItemsFound: 'Inga poster hittades',
  noMediaDefined: 'Ingen media har angivits',
  noMoreResults: 'Inga fler resultat',
  noPartCollectionsFound: 'Ingen {partCollection} hittades.',
  noPartsSelected: 'Inga artiklar valda.',
  noPrice: 'Ring för pris',
  noResults: 'Inga resultat',
  noSearchResultsHelpText: 'Inga resultat hittades',
  noSearchableCategories: 'Inga sökbara kategorier',
  noSearchableTags: 'Inga sökbara taggar',
  noSuggestions: 'Inga förslag för sökterm',
  noSupercedingPartsFoundForPartNumber: 'Inga ersättningsdelar har hittats för detta artikelnummer.',
  noTagsFound: 'Inga taggar hittades',
  noTenantSuppliers: 'Tenant har inga leverantörer tilldelade.',
  noUnsavedChanges: 'Inga osparade ändringar',
  noWidgetKeys: 'Inga widget-nycklar har angivits.',
  node: 'Nod',
  nonSearchableFieldsSuccessfullyUpdated: 'Icke sökbara fält har uppdaterats.',
  none: 'Ingen',
  norwegianDescription: 'Beskrivning på norska',
  norwegianName: 'Norskt Namn',
  notAvailable: 'Ej tillämpligt',
  notImplemented: 'Inte implementerat',
  notMapped: 'Ej Kartlagd',
  notOrderable: 'Kan inte beställas',
  notSelected: 'Ej vald',
  notification: 'Meddelande | Meddelanden',
  notificationsMessage: 'Viktiga meddelanden och nyheter',
  november: 'November',
  numberOf: 'antal {item}',
  numeric: 'Numerisk',
  october: 'Oktober',
  of: 'av',
  off: 'Av',
  offlineContent: 'Offline-innehåll',
  ok: 'OK',
  oldPassword: 'Tidigare lösenord',
  on: 'På',
  opacity: 'Opacitet',
  open: 'Öppna',
  openItem: 'Öppna {item}',
  openTab: 'Öppna länk i ny flik',
  optimizeIndexJob: 'Optimera Index',
  optionalConfiguration: 'Valfri konfiguration | Valfria konfigurationer',
  options: 'Alternativ',
  order: 'Beställning | Beställningar',
  orderAttachmentHelpText: 'Du kan bifoga upp till 10 filer, där varje fil får vara högst 50 MB. Tillåtna filformat: pdf, doc, docx, xls, xlsx, txt, rtf, ppt, pptx, xml, zip, jpg, jpeg, gif, png, bmp, tiff, tif, mp4, mpg, mpeg, avi, mov, rm, wmv, flv, f4v och svg',
  orderDisable: 'Inaktivera Beställningshistorik',
  orderEmailRecipient: 'Mottagare av e-post om beställning | Mottagare av e-post om beställning',
  orderEntity: 'Beställningsenhet | Beställningsenheter',
  orderField: {
    nameMessage: 'Om du ändrar fältet med beställningens/anbudets namn, säkerställ att alla beställningar, anbud eller mejlformat som använder detta fält också är uppdaterade.'
  },
  orderFieldCopyMessage: 'Ange ett unikt namn för det nya fältet för beställning/anbud',
  orderFieldUneditableRequired: 'Att ställa in ett fält för beställning/anbud som ”obligatoriskt” och ”går ej att redigera av användare” kan göra att beställningen/anbudet inte går att slutföra. Vänligen säkerställ att din beställning/ditt anbud kan slutföras.',
  orderFieldsEmptyMessage: 'Inga fält för beställning/anbud har angivits.',
  orderFieldsEmptyPrompt: 'Lägg till ett fält för beställning/anbud',
  orderForm: {
    uniqueNameInputHint: 'Ange ett unikt namn för det nya Formuläret.'
  },
  orderFormField: 'Fält för beställning/anbud | Fält för beställning/anbud',
  orderFormLayout: 'Layout för beställnings-/anbudsformulär | Layouter för beställnings-/anbudsformulär',
  orderFormSetDefault: 'Ange Standardbeställning/Anbudsformulär',
  orderFormType: 'Beställningsformulär',
  orderLayout: 'Beställningslayout | Beställningslayouter',
  orderManagementApprover: 'Godkännare för beställningshantering',
  orderManagementDisable: 'Inaktivera admin för beställningshantering',
  orderManagementViewer: 'Läsare för beställningshantering',
  orderNumber: 'Beställningsnummer',
  orderQuoteDeleteWarning: 'Det går inte att ta bort fält som har tillämpats på en order eller offert, används i en e-postmall eller har använts på tidigare skickade order eller offerter.',
  orderQuoteEmail: 'Beställning/mejl med anbud | Beställning/mejl med anbud',
  orderQuoteEmailFormat: 'Format för beställning/mejl med anbud | Format för beställning/mejl med anbud',
  orderQuoteEmailFormatCopyMessage: 'Välj ett språk för den nya beställningen/mejlet med anbud',
  orderQuoteFetchError: 'Fel vid hämtning av data för beställning/anbudsformulär',
  orderQuoteForm: 'Formulär för beställning/offert | Formulär för beställningar/offerter',
  orderQuoteFormSaved: 'Beställnings-/anbudsformulär har sparats',
  orderQuoteSaveConfirmation: 'Spara dina förändringar på organisatorisk beställning/anbudsformulär?',
  orderQuoteSaveError: 'Fel då beställningens/anbudsformulärets data sparades',
  orderStatus: 'Status för beställning/anbud | Statusar för beställningar/anbud',
  orderStatusDeleteMessage: 'Denna status har använts för beställningar och kan inte tas bort.',
  orderSubmittedMessage: 'Skickad',
  orderSuggestion: 'Beställningsförslag | Beställningsförslag',
  orderSuggestionEnable: 'Aktivera beställningsförslag',
  orderSuggestionRemovalWarning: 'Artikeln kommer inte längre att visas som beställningsförslag. | Artiklarna kommer inte längre att visas som beställningsförslag.',
  orderSuggestionThreshold: 'Tröskel för beställningsförslag',
  orderable: 'Beställningsbar',
  orderableDescription: 'Artikeln kan läggas till i kundvagnen och köpas',
  orderableLocal: 'Kan beställas på denna sida',
  orderableLocalBlocked: 'Artikeln kan inte beställas globalt',
  ordersLogo: 'Beställningslogotyp',
  ordersMessage: 'Historik över inlämnade beställningar',
  org: 'Org',
  orgAccessControlsWarning: 'Obs! Överordnade organisationer (t.ex. föregångare) har alltid automatiskt åtkomst till innehåll som tilldelats någon av deras underordnade organisationer.',
  orgEmailRecipients: 'Organisationens e-postmottagare',
  orgNameOnly: 'Endast Namn på Org',
  organization: 'Organisation | Organisationer',
  organizationAdmin: 'Organisationens administratör',
  organizationAdminBrowseFlow: 'En organisation kan använda standardflödet, eller så kan du åsidosätta och använda något annat flöde.',
  organizationAdminMessage: 'Styr användarhantering och organisationens inställningar',
  organizationEmailRecipients: 'Organisationens e-postmottagare',
  organizationEmpty: 'Organisationen måste väljas',
  organizationEnforceAccessControlsForQuickAdd: 'Tillämpa ÅtkomstKontroller för Snabb Tilläggning',
  organizationKey: 'Organisationsnyckel',
  organizationLibrarySettingsDescription: 'Dessa inställningar styr olika biblioteksdelar och alternativ på organisationsnivå. Var försiktig när du utför ändringar. Kontakta Documoto-tjänster för mer information.',
  organizationMoveToRoot: 'Släpp här för att flytta till roten',
  organizationName: 'Namn på organisation',
  organizationRearrange: 'Ordna om organisationer',
  organizationRearrangeDescription: 'Organisationsstrukturen ”överordnad-underordnad” definierar många ärftliga attribut för en organisation, så som utskriftsinställningar, stilar med flera. Dra och släpp organisationer för att visa önskad hierarki.',
  organizationReportSettingsSuccessMessage: 'Rapportinställningar har sparats',
  organizationSelect: 'Välj organisation',
  organizationTags: 'Organisationstaggar',
  organizationsEmpty: 'Det verkar som att du inte har skapat några organisationer än',
  orientation: 'Orientering',
  other: 'Annat',
  otherSettings: 'Andra inställningar',
  outboundCustomerIdParameter: 'Parameternamn för utgående kund-ID',
  outboundSessionIdParameter: 'Parameternamn för utgående sessions-ID',
  outlineMode: 'Översiktsläge (Skift O)',
  output: 'Utmatning',
  outputCatalog: 'Katalog för Utmatning',
  outputDefinition: 'Definition för Utmatning | Definitioner för Utmatningar',
  outputDefinitionDeleted: 'Definition för Utmatning raderad',
  outputDefinitionSaved: 'Definition för Utmatning Sparad',
  outputDestination: 'Destination för utmatning',
  outputFileName: 'Namn på Fil med Utmatning',
  outputName: 'Namn på Utmatning',
  outputSpecification: 'Uppgift om utmatning',
  outputSubType: 'Utmatningens Undertyp',
  outputType: 'Typ av Utmatning',
  overridden: 'Åsidosatt',
  overriddenByOrg: 'Åsidosatt av organisationen',
  override: 'Åsidosätt',
  overrideBrowseFlow: 'Åsidosätt flöde',
  overrideFacetLimitValue: 'Åsidosätt gränsvärde för aspekt',
  overrideFontSettings: 'Åsidosätt teckensnittsinställningar',
  overrideHotpointScale: 'Åsidosätt hotpoint-skala',
  overrideOrderForm: 'Åsidosätt beställningsformulär',
  overridePdfNamingStandard: 'Åsidosätt standard för namngivning av PDF-filer',
  overridePrintSettings: 'Åsidosätt utskriftsinställningar',
  overrideQuoteForm: 'Åsidosätt anbudsformulär',
  overrideSvgOpacity: 'Åsidosätt SVG-opacitet',
  overrideWarning: 'Import av data kommer att ersätta din befintliga stycklista',
  owner: 'Ägare | Ägare',
  page: 'Sida | Sidor',
  pageBomPartsDeleted: '{count} delar av BOM-sidan kommer inte längre att vara tillgängliga från {filename}.',
  pageBuilder: 'SidByggare',
  pageBulkErrorTooManyBooks: 'Begränsa antal valda böcker till maximalt 1 000 stycken',
  pageBulkInsertBooksConfirmInsertAfter: 'Detta kommer att föra in {replacement} efter {original} i {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertBooksConfirmInsertBefore: 'Detta kommer att föra in {replacement} innan {original} i {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertBooksConfirmInsertReplace: 'Detta kommer att föra in {replacement} och radera {original} i {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertConfirmInsertAfter: 'Detta kommer att föra in {replacement} efter {original} i {whereUsedBookCount} {bookUnits} och {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmInsertBefore: 'Detta kommer att föra in {replacement} innan {original} i {whereUsedBookCount} {bookUnits} och {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmInsertReplace: 'Detta kommer att föra in {replacement} och radera {original} i {whereUsedBookCount} {bookUnits} och {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmTitle: 'Vill du slutföra massinfogningen?',
  pageBulkInsertDiscard: 'Din massinfogning bearbetas inte.',
  pageBulkInsertHelpText: 'Denna funktion möjliggör att du infogar denna källsida {thisDisplayName} i valda delar av böcker där en annan sida {originalDisplayName} redan finns. Om du vill kan du även ta bort {originalDisplayName} från böckerna.',
  pageBulkInsertInsertAfter: 'Infoga {replacement} EFTER {original}',
  pageBulkInsertInsertBefore: 'Infoga {replacement} FÖRE {original}',
  pageBulkInsertInsertReplace: 'Infoga {replacement} och TA BORT {original}',
  pageBulkInsertScopeAll: 'Alla {type} som har målsidan {originalDisplayName} ({whereUsedCount} {units})',
  pageBulkInsertScopeNone: 'Ingen av {type} som har målsidan {originalDisplayName}',
  pageBulkInsertScopeSome: 'Några av {type} som har målsidan {originalDisplayName}',
  pageBulkInsertStep1: 'Steg 1: Hitta önskad målsida',
  pageBulkInsertStep2: 'Steg 2: Bestäm hur du vill infoga eller ersätta sidorna',
  pageBulkInsertStep3: 'Steg 3: Välj de böcker där du vill att massinfogningen ska bearbetas',
  pageBulkInsertStep4: 'Steg 4: Välj de mallar där du vill att massinfogningen ska bearbetas.',
  pageBulkInsertSuccessBody: 'Ändringar till bokens innehållsförteckning görs omedelbart. Sökresultat visas när indexeringen har slutförts.',
  pageBulkInsertSuccessTitle: 'Massinfogningsjobb har lämnats in',
  pageBulkInsertTemplatesConfirmInsertAfter: 'Detta kommer att föra in {replacement} efter {original} i {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertTemplatesConfirmInsertBefore: 'Detta kommer att föra in {replacement} innan {original} i {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertTemplatesConfirmInsertReplace: 'Detta kommer att föra in {replacement} och radera {original} i {whereUsedTemplateCount} {templateUnits}.',
  pageComposer: 'Page Composer',
  pageCreated: 'Sida skapad',
  pageDeleteMessage: 'Raderade sidor kommer omedelbart att tas bort i administration av bibliotek och innehåll. Den borttagna sidan kommer att vara sökbar tills en ny registrering har skett inom några minuter.',
  pageDeleteMessage2: 'Denna åtgärd kan inte ångras utan hjälp från Documoto Support. Efter 90 dagar kommer den borttagna uppgiften och allt som är kopplat till den att raderas permanent.',
  pageDescription: 'Beskrivning av sida',
  pageDraftsDeleted: 'Sidor med utkast som är kopplade till denna sida kommer att raderas permanent.',
  pageFile: 'Sidfil',
  pageFileRequired: 'En sidfil krävs.',
  pageFilename: 'Sidans filnamn',
  pageFilenameDeleted: '{filename} kommer att raderas.',
  pageFit: 'Anpassa sida',
  pageHeader: 'Sidrubrik',
  pageLabel: 'Sida | Sidor',
  pageLayout: 'Sidlayout',
  pageName: 'Sidans namn',
  pagePart: 'Del av sida | Delar av sida',
  pagePartData: 'Data för Del av Sida',
  pagePartLevelDetails: 'Del av sida för beställningsbara/synliga, taggar för del av sida',
  pagePartNumberVisible: 'Sidnummer Synligt',
  pagePartOrderable: 'Del av sida kan Beställas',
  pagePartOrderableDescription: 'Del kan Beställas från denna sida',
  pagePartTag: 'Tagg för Del av sida | Taggar för Delar av sidor',
  pagePartVisibleDescription: 'Delnummer synligt på denna sida',
  pageToPartCollectionFailure: 'Det gick inte att lägga till sida {name} som en artikelsamling.',
  pageUpdated: 'Sida uppdaterad',
  pageUsageDataCouldNotBeLoaded: 'Det gick inte att ladda data för sidanvändning',
  pageViewer: 'SidGranskare',
  pageWidth: 'Sidbredd',
  pagesWhereUsed: 'Sidor där detta används',
  parentName: 'Namn på överordnad',
  part: 'Artikel | Artiklar',
  partCode: 'Artikelkod | Artikelkoder',
  partCodeAddError: 'Det går inte att lägga till artikelkod(er)',
  partCodeErrorEmpty: 'Det gick inte att spara: Artikelkod får inte vara tom',
  partCodeErrorInUse: 'Denna artikelkod används av artiklar i Documoto och kan inte tas bort. Kontakta Documoto Support på support{\'@\'}documoto.com för hjälp.',
  partCodeErrorNotFound: 'Denna artikelkod kunde inte tas bort eftersom den inte hittades. Se till att alla ändringar har sparats.',
  partCodesManager: 'Artikelkodhanterare',
  partCodesMessage: 'Artikelkoder kan användas i stället för artikelnummer och används ofta för att ange när strukturposter är inaktuella, ej tillgängliga eller endast referens (t.ex. \'PNNA\', \'-\', \'REF\').',
  partCollection: 'Komponentsamling | Komponentsamlingar',
  partCollectionsDescription: 'Lägg till upp till 20 {parts} {pages} som ska visas som {collections} på denna {productPage}.',
  partCollectionsDescription2: 'De valda {collections} avgör vilka {parts} som är tillgängliga för slutanvändare för snabb åtkomst eller beställning.',
  partCollectionsDescription3: 'Den ordning som anges nedan styr hur de visas i Library {productPage} Viewer.',
  partCollectionsLimitError: 'Maximalt {limit} {item1} tillåts per {item2}.',
  partCreated: 'Artikel skapad',
  partData: 'Data om Del',
  partDebouncerEmailQueueJob: 'Mejlkö',
  partDescription: 'Beskrivning av artikel',
  partEquipmentVerificationBanner: 'Banner för kontroll av delutrustning',
  partLabel: 'Artikel | Artiklar',
  partLevelDetails: 'Prissättning av delar, beställningsbara/synliga, ytterligare översättningar, taggar för delar',
  partName: 'Artikelnamn',
  partNumber: 'Artikelnummer',
  partNumberCopied: '{label} har kopierats till urklipp',
  partNumberDescription: 'Det interna artikelnumret som slutanvändare kan söka',
  partNumberSupercededBy: '{partNumber} existerar som ett SupersededPartNumber-tagg på...',
  partNumberVisible: 'Artikelnummer synligt',
  partNumberVisibleDescription: 'Artikelnummer synligt för slutanvändare',
  partNumberVisibleLocal: 'Synlig på denna sida',
  partNumberVisibleLocalBlocked: 'Artikelnummer inte synligt globalt',
  partOrderable: 'Del kan Beställas',
  partRequired: 'Minst en artikel krävs',
  partTag: 'Tagg för del | Taggar för delar',
  partTagProperty: 'Egenskap för artikeltagg | Egenskaper för artikeltagg',
  partUpdated: 'Del uppdaterad',
  partVerificationInstructions: 'Kontrollera att delen passar din enhet',
  partialSupport: 'Delvis support',
  partnerApiKey: 'Partners API-Nyckel',
  partnerRESTRequestLimit: 'Gräns för partners REST-begäran',
  partsBook: 'Artikelbok | Artikelböcker',
  partsBulkImport: {
    description: 'Ladda upp din datafil för att skicka bearbetning av massimport av delar. Filformat som stöds: XLSX.',
    downloadTemplate: 'Ladda ned XLSX-mall',
    downloadUnprocessedRows: 'Ladda ned obearbetade rader i kalkylark',
    hideRequirements: 'Dölj XLSX-krav',
    overwriteTagValues: 'Skriv över taggvärden för matchande taggar',
    overwriteTranslations: 'Skriv över matchande översättningar',
    requirements: {
      discountPrice: {
        description: 'Anger det kundspecifika rabattpriset.'
      },
      enUSDescription: {
        description: 'Språkspecifik översättningstext för en komponent. Se vår <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">guide för språkstöd</a>.'
      },
      enUSName: {
        description: 'Språkspecifikt översatt namn på en komponent. Minst en översättning krävs för nya komponenter. Se vår <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">guide för språkstöd</a>.'
      },
      orderable: {
        description: 'Anger om delen är beställningsbar. Tillåtna värden är `true` eller `false`. Standardvärdet är `true`.'
      },
      orgDiscountPrice: {
        description: 'Anger det organisationsspecifika rabattpriset för en angiven organisation. Exempel på rubrik: `<OrganizationName> / Discount Price`'
      },
      orgRetailPrice: {
        description: 'Anger det organisationsspecifika detaljhandelspriset för en angiven organisation. Exempel på rubrik: `<OrganizationName> / Retail Price`'
      },
      orgWholesalePrice: {
        description: 'Anger det organisationsspecifika grossistpriset för en angiven organisation. Exempel på rubrik: `<OrganizationName> / Wholesale Price`'
      },
      partNumber: {
        description: 'Ett unikt artikel-ID för komponenten.'
      },
      retailPrice: {
        description: 'Anger det kundspecifika detaljhandelspriset.'
      },
      supplier: {
        description: 'Namnet på komponentens leverantör.'
      },
      tagInternalName: {
        description: 'Tilldelar taggar till delen. Kolumnrubriken måste vara taggens interna namn. Använd avgränsaren &#124; för flera värden. Exempel: Röd&#124;Grön&#124;Blå.'
      },
      thumbnail: {
        description: 'Filnamn för miniatyrbild. Tillåtna filändelser: .png, .jpg, .jpeg, .gif'
      },
      uom: {
        description: 'Enhet (t.ex. "styck", "enhet").'
      },
      visible: {
        description: 'Anger om komponenten ska vara synlig. Tillåtna värden är`true` eller `false`. Standardvärdet är `true`.'
      },
      wholesalePrice: {
        description: 'Anger det kundspecifika grossistpriset.'
      }
    },
    showRequirements: 'Visa XLSX-krav',
    submitNote: 'Om du klickar på "Skicka" startar ett jobb i bakgrunden och leder dig till sidan "Jobbhanterare".',
    success: 'Jobb för massimport av delar har skapats',
    title: 'Massimport av delar'
  },
  partsColumns: 'Artikelkolumner',
  partsDisplay: 'Visade delar',
  partsList: 'Lista över Delar',
  partsListColumn: 'Kolumn i artikellista | Kolumner i artikellista',
  partsListData: 'Artikellistdata',
  partsListGridHeader: 'Artikellistans rutnätsrubrik',
  partsNotSelected: 'Standardbild som används för artikelminiatyrbilder. Om en anpassad miniatyrbild inte tillämpas visar Documoto en standardminiatyrbild.',
  partsPage: 'Sida med Delar | Sidor med Delar',
  partsPageGroup: {
    columnsLoadErrorMsg: 'Det gick inte att läsa in artikelkolumnerna',
    columnsUpdateErrorMsg: 'Ett fel uppstod vid försök att uppdatera artikelkolumnerna',
    columnsUpdateSuccessMsg: 'Artikelkolumnerna har uppdaterats',
    cropWhitespaceOnImages: 'Beskär vita områden på bilder',
    excludePartCodesFromPartsLists: 'Exkludera artikelkoder från artikellistorna',
    highlightAlternateRows: 'Markera alternativa rader',
    keepBOMOnRight: 'Håll strukturposter till höger',
    keepImagesOnLeft: 'Håll bilderna till vänster',
    printBorderAroundImages: 'Skriv ut kant runt bilderna',
    printHotpointsOnImages: 'Pränta Hotpoints på Bilder',
    rotateImagesAutomatically: 'Rotera bilder automatiskt'
  },
  partsPages: 'Artikelsidor',
  password: 'Lösenord',
  passwordBlankMessage: 'Lösenordet kan inte vara tomt',
  passwordCannotBeSame: 'Får inte vara samma som ditt nuvarande lösenord',
  passwordCasingMassage: 'Måste innehålla åtminstone en liten och en stor bokstav',
  passwordCriteriaInfo: 'Ditt nya lösenord måste uppfylla följande kriterier:',
  passwordExpiredHeader: 'Lösenordet har gått ut',
  passwordExpiredInfo: 'Ditt lösenord har gått ut. Ditt nya lösenord måste uppfylla följande kriterier:',
  passwordLowerCaseMessage: 'Lösenordet måste innehålla minst en gemen',
  passwordMinLengthMessage: 'Lösenord måste innehålla minst 8 tecken',
  passwordNotMatchingMessage: 'Lösenorden stämmer inte överens',
  passwordOptions: 'Lösenordsalternativ',
  passwordOptionsRequired: 'Fältet för lösenord kan inte vara tomt',
  passwordSpecialCharactersMessage: 'Lösenordet måste innehålla minst ett specialtecken',
  passwordUpperCaseMessage: 'Lösenordet måste innehålla minst en versal',
  passwordWillExpire1Day: 'Lösenord för inloggning kommer att gå ut om mindre än en dag',
  passwordWillExpire5Days: 'Lösenord för inloggning kommer att gå ut om mindre än fem dagar',
  passwordsMatch: 'Lösenorden matchar',
  pdfImport: {
    aiPdfImports: 'AI-import av PDF-filer',
    aiPdfImportsDescription: 'Hantera AI-baserade PDF-importer för automatisk innehållsbearbetning.',
    createImport: 'Ny AI-import av PDF-fil',
    createImportDescription: 'Välj en PDF-källfil och konfigurera inställningarna för extrahering. Filbegränsningar: filstorlek högst 500MB och högst 3000 sidor.',
    defaultPartNumberCode: 'Standardkod för artikelnummer',
    defaultTranslationLocale: 'Standardspråk för översättning',
    defaultUomHelpText: 'Används när en kolumn för enhet inte är mappad eller när en extraherad rad i materialförteckningen inte innehåller något enhetsvärde.',
    defaultUomRequired: 'Obligatoriskt om inte enhet anges',
    dropFileMessage: 'Släpp fil här eller klicka för att ladda upp',
    fileSizeError: 'Filstorleken överskrider gränsen på 500 MB',
    importCreatedError: 'Det gick inte att skapa importen',
    importCreatedSuccess: 'Importen har skapats och placerats i kö för bearbetning',
    mapColumnToTag: 'Mappa kolumn till sidans deltagg',
    monthlyLimitExceeded: 'Den månatliga sidgränsen för AI PDF-importer skulle överskridas. Kontakta din Customer Success Manager för hjälp.',
    pageNumberFilterInvalidRange: 'Ogiltigt sidnummerintervall',
    pageNumberFilterPlaceholder: 't.ex. 6, -7, 8-, 9-20',
    partNumberCodeHelp: 'Artikelnummerkoden används för rader i materialförteckningen där värdet för artikelnummer är tomt',
    pdfImport: 'PDF-import | PDF-importer',
    pdfImportsDescription: 'Hantera AI-drivna PDF-importer för att automatiskt extrahera deldata från PDF-dokument',
    publishModalFooterHelp: 'När du klickar på ”Publicera” placeras ett bakgrundsjobb i kö och startas. Därefter omdirigeras du till sidan AI PDF-importer, där du kan följa publiceringsstatusen.',
    publishSkipAutoHotpointing: 'Hoppa över automatisk hotpoint-markering på sidan | Hoppa över automatisk hotpoint-markering på sidor',
    publishingFinishedNone: 'Publiceringen av importen "{importName}" är slutförd. Inga sidor publicerades.',
    publishingFinishedPartial: 'Publiceringen av importen "{importName}" är slutförd. {success} sida publicerades och {failed} kunde inte publiceras. | Publiceringen av importen "{importName}" är slutförd. {success} sidor publicerades och {failed} kunde inte publiceras.',
    publishingFinishedSuccess: 'Publiceringen av importen "{importName}" är slutförd. {count} sida publicerades. | Publiceringen av importen "{importName}" är slutförd. {count} sidor publicerades.',
    reviewStatusAll: 'Status: Alla',
    reviewStatusApproved: 'Godkänd',
    reviewStatusDropped: 'Borttagen',
    reviewStatusNoStatus: 'Ingen status',
    reviewStatusNone: 'Ingen',
    reviewStatusPending: 'Väntande',
    selectPagePartTag: 'Välj deltagg för sida',
    statusDeclined: 'Nekad',
    statusFailed: 'Misslyckad',
    statusPending: 'Väntande',
    statusProcessing: 'Bearbetar',
    statusPublished: 'Publicerad',
    statusPublishing: 'Publicerar',
    submitNote: 'När du klickar på ”Skicka” läggs ett bakgrundsjobb i kö och startas, och du återgår till hanteringssidan för AI PDF-importer där du kan följa importstatusen.'
  },
  pdfImportBom: {
    columnMatchStatus: 'Matchningsstatus',
    columnPagePartTag: 'Sida-deltagg',
    columnPartNameWithLocale: 'Komponentnamn ({locale})',
    emptyState: 'Inga poster i materialförteckningen hittades',
    existingPartNameApplied: 'Befintliga deldata har tillämpats',
    title: 'Materialförteckning'
  },
  pdfImportIllustrations: {
    adjustBoundsButton: 'Justera illustrationsgränser',
    boundsAdjusted: 'Gränser justerade',
    emptyState: 'Inga illustrationer för denna sida.',
    hiresUnavailableError: 'Högupplöst bild är inte tillgänglig för denna sida.'
  },
  pdfImportOverview: {
    actionApproveSelected: 'Godkänn markerade ({count})',
    actionClearStatusSelected: 'Rensa status för markerade ({count})',
    actionCopySelected: 'Slå samman med den första markerade sidan',
    actionDeleteImport: 'Ta bort AI PDF-import',
    actionDropSelected: 'Markera som borttagna ({count})',
    actionPendingSelected: 'Ange status för markerade som väntande ({count})',
    actionPublishSelected: 'Publicera markerade',
    autoMergeAction: 'Automatisk sammanslagning av sidor',
    autoMergeConfirmHelp: 'Automatisk sammanslagning av sidor hittar sidor med samma sidnamn och slår samman varje matchande grupp med den första sidan i den visuella ordningen. Källsidor som slås samman med en målsida får statusen Borttagen. Granska resultatet innan publicering.',
    autoMergeConfirmTitle: 'Ska sidor med matchande namn slås samman automatiskt?',
    autoMergeFailed: 'Automatisk sammanslagning misslyckades. Inga ändringar gjordes',
    autoMergeSuccess: 'Automatisk sammanslagning slutförd: {count} grupper har slagits samman, {dropped} sidor har markerats som borttagna',
    composedPageIndicator: 'Den här sidan innehåller kopierat innehåll från andra PDF-sidor.',
    contentTypeAll: 'Alla innehållstyper',
    contentTypeBomOnly: 'Endast materialförteckning',
    contentTypeBoth: 'Både materialförteckning och illustrationer',
    contentTypeEmpty: 'Tomma sidor',
    contentTypeFilterLabel: 'Innehållstyp',
    contentTypeIllustrationsOnly: 'Endast illustrationer',
    importSettings: 'Importinställningar',
    includeDroppedPagesLabel: 'Inkludera sidor markerade som borttagna',
    incompleteBomFilterLabel: 'Visa sidor med ofullständig materialförteckning',
    mergeConfirmSourcePages: '{count} källsida vald: | {count} källsidor valda:',
    mergeConfirmTitle: 'Ska markerade sidor slås samman med den första markerade sidan?',
    mergeConfirmTarget: 'Målsida: {pageLabel}',
    mergeFailed: 'Det gick inte att slå samman sidor med den första markerade sidan',
    mergeSuccess: 'Sidor har slagits samman till {pageLabel} ({bomCount} poster i materialförteckningen, {illustrationCount} illustrationer)',
    noPages: 'Inga sidor tillgängliga',
    noPagesHint: 'Den här importen innehåller inga sidor',
    noResults: 'Inga matchande sidor hittades',
    noResultsHint: 'Försök att justera sökningen eller filtren',
    notificationLoadFailed: 'Det gick inte att läsa in översikten',
    notificationReviewStatusUpdated: '{count} sidor har uppdaterats',
    notificationSelectAllFailed: 'Det gick inte att markera alla sidor',
    notificationUpdateReviewStatusFailed: 'Det gick inte att uppdatera granskningsstatusen',
    publishBookIdentifierNotUnique: 'Bokidentifieraren måste vara unik.',
    publishBookIdentifierTakenHelp: 'Det finns redan en bok med denna identifierare.',
    publishFailed: 'Det gick inte att publicera de valda sidorna',
    publishModalTitle: 'Publicera valda sidor',
    publishNewBookHelpText: 'Sidor som publiceras läggs till i den nya boken i samma ordning som de visas i översikten för AI PDF-import. En ny bok skapas endast om minst en av de valda sidorna publiceras.',
    publishNewBookIdentifierLabel: 'Bokidentifierare',
    publishOptionNewBook: 'Skapa en ny bok och lägg till sidor i den',
    publishOptionPagesOnly: 'Publicera endast sidor',
    reviewManagement: 'Granskningshantering',
    reviewManagementTooltip: 'Använd granskningsstatusar för att organisera arbetet när du granskar det extraherade innehållet. Statusarna Godkänd, Väntar och Borttagen påverkar inte publiceringen. De används endast för att följa granskningsförloppet.',
    reviewProgress: 'Granskningsförlopp',
    title: 'Översikt'
  },
  pdfImportPageDetails: {
    actionPublish: 'Publicera sidan',
    firstPage: 'Första sidan',
    lastPage: 'Sista sidan',
    matchingPageNewPage: 'Sida med nya delar',
    matchingPageNewPageSharedSvg: 'Ny sida med delar, men SVG-filen delas med andra sidor',
    matchingPageOpenExisting: 'Öppna befintlig sida',
    matchingPageOverwrite: 'Befintlig sida med delar kommer att skrivas över',
    navLabel: 'Översikt för AI PDF-import',
    navigationFailedText: 'Det gick inte att navigera till sidan {pageNumber}',
    nextPage: 'Nästa sida',
    notificationLoadFailed: 'Det gick inte att ladda sidan',
    notificationPublishFailed: 'Det gick inte att skicka publiceringsjobbet',
    notificationSaveFailed: 'Det gick inte att spara sidan',
    notificationSaveSuccess: 'Sidan har sparats',
    pageOriginComposed: 'Sammansatt av flera PDF-sidor',
    pageOriginExtracted: 'Extraherad från en PDF-sida',
    pageOriginLabel: 'Sidans ursprung',
    previousPage: 'Föregående sida',
    publishPageModalHelpText: 'Denna sida med delar kommer att publiceras utan koppling till en bok. Vid publicering skapas en ny sida med delar eller så skrivs en befintlig sida över enligt reglerna för sididentitet.',
    thumbnailCardTitle: 'Miniatyrbild för PDF-sida',
    viewBom: 'Materialförteckning'
  },
  pdfImportPublishingHistory: {
    bookResultCreated: 'Skapad',
    columnPdfPage: 'PDF-sida/-sidor',
    columnPublishingStatus: 'Publiceringsstatus',
    detailLoadFailed: 'Det gick inte att läsa in information om publiceringsjobbet',
    emptyBookOperations: 'Inga bokåtgärder utfördes i detta jobb.',
    emptyJobsHint: 'Publiceringsaktivitet visas här när sidor har publicerats.',
    emptyJobsTitle: 'Inga publiceringsjobb har ännu körts för denna AI PDF-import.',
    emptyPagesTitle: 'Inga sidor matchar det valda filtret.',
    filterAllPages: 'Visa alla sidor',
    filterFailedOnly: 'Visa endast misslyckade sidor',
    filterNameQuery: 'Namn eller sidfil',
    filterPublishedOnly: 'Visa endast publicerade sidor',
    helpText: 'Den här sidan visar historiken för publicerade sidor med delar från denna AI PDF-import, inklusive sidor som skapats, skrivits över eller misslyckats vid publicering.',
    jobLabel: 'Jobbnummer{number}',
    loadFailed: 'Det gick inte att läsa in publiceringshistoriken',
    resultPublishedCreated: 'Publicerad – Skapad',
    resultPublishedUpdated: 'Publicerad – Överskriven',
    resultSummaryBookCreated: 'En ny bok skapades.',
    resultSummaryNone: 'Inga sidor publicerades.',
    resultSummaryPagesFailed: '{n} sida kunde inte publiceras. | {n} sidor kunde inte publiceras.',
    resultSummaryPagesPublished: '{n} sida har publicerats. | {n} sidor har publicerats.',
    statusFailed: 'Misslyckad',
    statusInProgress: 'Pågår',
    title: 'Publiceringshistorik'
  },
  permission: 'Behörighet | Behörigheter',
  phoneNumber: 'Telefonnummer',
  phoneNumberExt: 'Ankn',
  phonePrimary: 'Primärt telefonnummer',
  phoneSecondary: 'Sekundärt telefonnummer',
  pinFilter: 'Fäst filter på sökresultatsidan',
  pinned: 'Fastnålad',
  plusMoreOrgs: '+ {totalOrgCount} ytterligare organisationer',
  polishDescription: 'Beskrivning på polska',
  polishName: 'Polskt Namn',
  populatePdfNameSelection: 'Val för att befolka PDF:ens filnamn',
  populatePdfNameWith: 'Befolka PDF:ens filnamn med',
  port: 'Port',
  portrait: 'Stående',
  portugueseDescription: 'Beskrivning på portugisiska',
  portugueseName: 'Portugisiskt Namn',
  postComment: 'Publicera kommentar',
  postalCode: 'Postnummer',
  poweredBy: 'Drivs av',
  preferences: 'Preferenser',
  preferencesDisable: 'Inaktivera användarpreferenser',
  prefix: 'Prefix | Prefix',
  preview: 'Förhandsvisning',
  previewOfName: 'Förhandsgranskning av {name}',
  pricing: 'Prissättning',
  pricingDiscountEnabled: 'Visa rabatterat pris',
  pricingDisplayInCart: 'Visa priser i kundvagnen',
  pricingDisplayInPartsList: 'Visa priser i artikellistan',
  pricingGlobal: 'Global prissättning',
  pricingGlobalDescription: 'Det normala priset om det inte finns någon åsidosättning av organisationen',
  pricingHideInitially: 'Dölj pris initialt',
  pricingHidePricingButton: 'Aktivera knappen Dölj pris',
  pricingHidePricingButtonDisable: 'Inaktivera knappen Dölj pris',
  pricingHidePricingButtonDisableHelp: 'Om knappen Dölj priser inaktiveras kan användare inte längre visa eller dölja prisnivåer. Alla prisnivåer som har konfigurerats med "Dölj pris initialt" förblir dolda och användare kan inte visa dem.',
  pricingOrganization: 'Organisationspris',
  pricingOrganizationDeleteConfirm: 'Vill du ta bort denna organisationsprissättning?',
  pricingOrganizationDescription: 'Organisationsprissättning åsidosätter global prissättning för alla användare inom en organisation och dess underordnade organisationer.',
  pricingOrganizationDuplicate: 'Denna organisation åsidosätts redan',
  pricingOrganizationEmptyState: 'Inga organisationsåsidosättningar har definierats. Klicka på {add} för att komma igång.',
  pricingRetailEnabled: 'Visa detaljhandelspris',
  pricingWholesaleEnabled: 'Visa grossistpris',
  primary: 'Primär',
  print: 'Skriv ut',
  printJob: 'Utskriftsjobb',
  printLogo: 'Skriv ut logotyp',
  printSetting: 'Utskriftsinställning',
  printSettingCopyMessage: 'Ange ett unikt namn för den nya utskriftsinställningen.',
  printSettingCreated: 'Utskriftsinställning har skapats',
  printSettingDeleteFail: 'Det gick inte att ta bort utskriftsinställningen',
  printSettingEmptyMessage: 'Inga utskriftsinställningar har definierats. Lägg till en utskriftsinställning för att komma igång.',
  printSettingSaveFail: 'Det gick inte att spara utskriftsinställningen',
  printSettingSelectionRequired: 'Val av utskriftsinställning krävs.',
  printSettingSetDefaultSuccess: 'Standardinställning för utskrift har ställts in',
  printSettingUpdateFail: 'Det gick inte att uppdatera utskriftsinställningen',
  printSettings: 'Utskriftsinställningar',
  printSettingsLogo: 'Utskriftsinställningar logotyp',
  printerLane: 'Skrivarbana',
  printing: 'Skriver ut',
  printingDisabled: 'Inaktivera all utskrift',
  privacyPolicy: 'Integritetspolicy',
  proceed: 'Fortsätt',
  process: 'Process',
  processContent: 'Bearbeta innehåll',
  processToDraft: 'Behandla för utkast',
  processedPlzToDraft: 'Behandlade PLZ(er) till utkast',
  processing: 'Bearbetar',
  productCategory: 'Produktkategori | Produktkategorier',
  productCategoryName: 'Namn på produktkategori',
  productId: 'Produkt-ID',
  productIdErrorMessage: 'Produkt-ID krävs',
  productIdMessage: 'Det identifieringsvärde som används för att hitta produkten, t.ex. ”FTX1000”',
  productPage: 'Produktsida | Produktsidor',
  productPageAccessControlDescription: 'Åtkomstkontroller definierar vem som är behörig att komma åt sidan baserat på organisationer och användargrupper.',
  productPageCreated: 'Produktsida skapad',
  productPageDescription: 'Produktsidans beskrivning',
  productPageIdentifierMessage: 'En unik intern referens för denna sida',
  productPageName: 'Produktsidans namn',
  productPageProductId: 'Produktsida Produkt-ID',
  productPageUpdated: 'Produktsidan uppdaterad',
  productPagesBulkImport: {
    description: 'Ladda upp din datafil för att starta massimport av produktsidor. Filformat som stöds: XLSX.',
    downloadUnprocessedRows: 'Ladda ned kalkylblad med ej bearbetade rader',
    overwriteAccessControls: 'Skriv över åtkomstkontroller (organisationer och användargrupper)',
    overwriteAssociatedMedia: 'Skriv över associerade medier',
    requirements: {
      enUSCategory: {
        description: 'Befintligt namn på produktkategori för ett visst språk. Se vår <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">språkstödsguide</a>.'
      },
      enUSDescription: {
        description: 'Språkspecifik översättning av beskrivningen för en produktsida. Se vår <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">språkstödsguide</a>.'
      },
      enUSName: {
        description: 'Språkspecifik översättning av namnet på en produktsida. Minst en översättning krävs för nya produktsidor. Se vår <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">språkstödsguide</a>.'
      },
      identifier: {
        description: 'En unik identifierare för en produktsida som endast är synlig och sökbar i Admin Center.'
      },
      media: {
        description: 'Lista över medieidentifierare kopplade till en viss produktsida. Använd avgränsaren &#124; för flera värden.'
      },
      organizations: {
        description: 'Lista över organisationer med åtkomst till en viss produktsida. Använd avgränsaren &#124; för flera värden.'
      },
      productId: {
        description: 'En produktsidesidentifierare för slutanvändare, synlig och sökbar i Library. Produkt-ID behöver inte vara unikt.'
      },
      tagInternalName: {
        description: 'Tilldelar taggar till en produktsida. Kolumnrubriken måste vara taggens interna namn. Använd avgränsaren &#124 för flera värden. Exempel: Röd &#124; Grön &#124; Blå.'
      },
      thumbnail: {
        description: 'Filnamn för miniatyrbild. Tillåtna filändelser: .png, .jpg, .jpeg, .gif'
      },
      userGroups: {
        description: 'Lista över användargrupper med åtkomst till en viss produktsida. Använd avgränsaren &#124 för flera värden.'
      }
    },
    success: 'Jobb för massimport av produktsidor har skapats',
    title: 'Massimport av produktsidor'
  },
  production: 'Produktion',
  professional: 'Expert',
  profile: 'Profil',
  prohibitExportDownloadOfContent: 'Förbjud exportering/nedladdning av innehåll',
  prohibitExportDownloadOfContentHelpText: 'Om \'Aktiverat\' har angivits så kommer det att hindra alla (privilegierade) användare från att ladda ner detta innehåll.',
  property: 'Egenskap | Egenskaper',
  province: 'Provins',
  'public': 'Offentlig',
  publish: 'Publicera',
  publishDocuments: 'Publicera Dokument',
  publishDraft: 'Publicera Utkast',
  publishThumbnailJob: 'Publicera Miniatyr',
  publisher: 'Publicerare | Publicerare',
  publisherJob: 'Publicerarjobb',
  publisherLane: 'Utgivarbana',
  publisherManualLane: 'Manuell utgivarbana',
  publisherMessage: 'Skapa och hantera innehåll och utskriftsinställningar',
  publishingErrors: 'PubliceringsFel',
  publishingErrorsWithName: 'Publiceringsfel {name}',
  publishingInProgress: 'Publicering pågår, kan inte skicka',
  purchaseOrder: 'Inköpsorder',
  purchaseOrderTemplateDisabled: 'Inaktivera beställningsmallar',
  purchaseOrderTemplateEnabled: 'Aktivera beställningsmallar',
  qty: 'Antal',
  quantity: 'Antal',
  query: 'Fråga',
  quickAdd: 'Lägg till snabbt',
  quickAddHelpText: 'Börja skriva för att hitta artiklar att lägga till i kundvagnen.',
  quickAddInCartEnabled: 'Aktivera Lägg till snabbt i kundvagnen',
  quickLinks: 'Snabblänkar',
  quote: 'Anbud | Anbud',
  quoteFormType: 'Anbudsformulär',
  quoteTemplateDisabled: 'Inaktivera offertmallar',
  quoteTemplateEnabled: 'Aktivera offertmallar',
  range: 'Intervall',
  rearrange: 'Ordna om',
  rebuildIndexJob: 'Återuppbygg Index',
  recentSearches: 'Senaste sökningar',
  recentlyAdded: 'Nyligen tillagda',
  recentlyEdited: 'Nyligen redigerade',
  recentlyViewed: 'Nyligen visade',
  recipientOrRecipients: 'Mottagare',
  rectangle: 'Rektangel',
  redirect: 'Omdirigera',
  refresh: 'Uppdatera',
  related: 'Relaterade',
  relatedDescription: 'Relatera media som finns i biblioteket till denna {type}. Observera att relaterade media måste tillämpa åtkomstkontroller för att användare ska kunna se dem i fliken \'Relaterat\' .',
  relatedInfo: 'Relaterad info',
  relatedView: 'Visa relaterade medier',
  relationship: 'Relation | Relationer',
  releaseNotes: 'Versionsmeddelande',
  remainingWidth: 'Återstående bredd',
  rememberMe: 'Kom ihåg mig',
  remove: 'Ta bort',
  removeAll: 'Ta bort alla',
  removeItemConfirmation: 'Vill du ta bort {item}?',
  removeItemCount: 'Är du säker på att du vill ta bort {count} {type}?',
  replace: 'Ersätt',
  replaceExisting: 'Ersätt befintliga',
  report: 'Rapport | Rapporter',
  reportAnIssue: 'Rapportera ett problem',
  reportAnIssueMessage: 'E-postmeddelandet har skickats.',
  reportCatalogName: 'Namn på RapportKatalog',
  reportCatalogNotSet: 'Rapportkatalog har inte angivits för rapporten.',
  reportDefinition: 'Definition av Rapport | Definitioner av Rapport',
  reportDefinitionDeleteError: 'Kunde inte radera definition av rapport',
  reportExportTimeWarning: 'En export kan ta flera minuter att slutföra beroende på antal uppgifter och det valda formatet.',
  reportSettings: 'Rapportinställningar',
  reporting: 'Rapportering',
  reportingMessage: 'Åtkomst till olika rapporter och mått',
  reportsEmptyState: 'Inga Rapporter',
  reportsLibrary: 'Rapportbibliotek',
  requestForQuote: 'Offertförfrågan',
  requestFormType: 'Anbudsformulär',
  requireAuthentication: 'Kräv autentisering',
  required: 'Obligatoriskt',
  requiredField: 'Obligatoriskt fält',
  requiredItem: '{item} krävs.',
  requiredMessage: 'En {item} krävs.',
  requiredMessageAndUnique: 'En {item} är obligatorisk och måste vara unik.',
  requiredReading: 'Obligatorisk läsning',
  requiredReadingMessage: 'Granska följande:  ',
  requiredType: 'Ett val krävs.',
  requiredUrlMessage: 'En URL i rätt format krävs.',
  reset: 'Återställ',
  resetPassword: 'Återställ lösenordet',
  resetPasswordError: 'Det gick inte att återställa ditt lösenord, försök igen.',
  resetPasswordTokenError: 'Lösenordets återställningstoken är ogiltig.',
  resetZoom: 'Återställ Zoom',
  resize: 'Ändra storlek',
  resizeThumbnails: 'Ändra automatiskt storlek på miniatyrbilder',
  resource: 'Resurs | Resurser',
  result: 'Resultat | Resultat',
  resultFor: 'Resultat för {item} | Resultat för {item}',
  retail: 'Detaljhandel',
  retailPrice: 'Detaljhandelspris',
  retailTotal: 'Summa detaljhandel',
  'return': 'Återvänd',
  returnToItem: 'Gå tillbaka till {item}',
  returnToMedia: 'Gå tillbaka till medier',
  returnToPartList: 'Gå tillbaka till artikellistan',
  returnToTemplate: 'Gå tillbaka till mall',
  returnToViewer: 'Återvänd till granskning',
  revert: 'Ångra',
  revertChanges: 'Ångra ändringar',
  revertChangesMsg: 'Är du säker på att du vill återställa dina ändringar?',
  right: 'Höger',
  romanianDescription: 'Beskrivning på rumänska',
  romanianName: 'Rumänskt Namn',
  rootLevelBrowseFlow: 'Rotnivå',
  row: 'Rad',
  russianDescription: 'Beskrivning på ryska',
  russianName: 'Ryskt Namn',
  s3DataExportsEnabled: 'Aktivera S3 dataexport',
  sampleData: 'Provdata',
  samplePreview: 'Förhandsvisning av urval',
  sandbox: 'Sandlåda',
  sat: 'Lör',
  save: 'Spara',
  saveAndClose: 'Spara och stäng',
  saveAndEditTarget: 'Spara och redigera mål',
  saveChanges: 'Spara dina ändringar till {item}? {name}',
  saveChangesToItem: 'Spara dina ändringar till denna {item}?',
  saveNewAPIKey: 'Ny Nyckel för Integrering är inte Sparad, Gå tillbaka för att slutföra installationen',
  saveNewWidgetKey: 'Ny widget-nyckel har inte sparats. Återvänd för att slutföra installation.',
  saveOrderAttachmentsError: 'Orderbilagor kunde inte sparas.',
  saved: 'Sparat',
  search: 'Sök',
  searchAllContent: 'Sök i allt innehåll',
  searchCategories: 'Kategorier',
  searchConfiguration: 'Sök-konfiguration',
  searchContent: 'Sök {content}',
  searchCriteria: 'Sökkriterier',
  searchDocumoto: 'Sök i Documoto',
  searchFeatures: 'Sökfunktioner',
  searchFieldConfigDescription: 'Följande sökinställningar för systemfältet gäller endast för allmänna biblioteksökningar, sidan för sökresultat och snabbtillägg i kundvagnen. Andra sökfunktioner (som exempelvis sökningar på administrationscentral och bibliotek där det används) påverkas inte.',
  searchInContent: 'Sök i {contentName}...',
  searchPlaceholder: 'Sök i allt innehåll...',
  searchPrompt: 'Sök i allt innehåll...',
  searchProperty: 'Sökegenskap | Sökegenskaper',
  searchResults: 'Sökresultat',
  searchResultsConfiguration: 'Konfiguration av sökresultat',
  searchSettings: 'Sökinställningar',
  searchSettingsDescription: 'Dessa inställningar styr olika sökbeteenden, funktioner och resultat i biblioteket.',
  searchTerm: 'Sökterm',
  searchTips: 'Söktips:',
  searchType: 'Typ',
  searchable: 'Sökbar',
  searchableFieldsSuccessfullyUpdated: 'Sökbara fält har uppdaterats.',
  searchableTag: 'Sökbar tagg',
  searchingInLanguage: 'Söker endast på {lang}',
  searchingInTwoLanguages: 'Söker endast på {lang1} och {lang2}',
  section: 'Avsnitt',
  select: 'Välj',
  selectAField: 'Välj ett {field}',
  selectAll: 'Välj alla',
  selectAndClose: 'Välj och stäng',
  selectChapters: 'Välj Kapitel',
  selectChildren: 'Välj underordnade',
  selectFields: 'Välj {field}',
  selectItem: 'Välj {item}',
  selectMedia: 'Välj Media',
  selectPage: 'Välj sida',
  selectPages: 'Välj Sida (Sidor)',
  selectTargetPage: 'Välj målsida',
  selected: 'Vald',
  selectedTargetPage: 'Vald målsida',
  send: 'Skicka',
  sendReverificationEmail: 'Skicka e-post för omverifiering',
  sendVerificationEmail: 'Skicka e-post för verifiering',
  september: 'September',
  sequence: 'Sekvens',
  serbianDescription: 'Beskrivning på serbiska',
  serbianName: 'Serbiskt Namn',
  serviceUri: 'Tjänstens URI',
  sessionLog: 'Sessionslogg',
  set: 'Ställ in',
  setAsDefault: 'Ställ in som standard',
  setPassword: 'Ställ in lösenord',
  settings: 'Inställningar',
  settingsMessage: 'Uppdatera dina användarinställningar och lösenord',
  shape: 'Form',
  shapeTool: 'Formverktyg',
  shared: 'Delat',
  sharedCart: 'Delad kundvagn | Delade kundvagnar',
  sharedCartDeleteContent: 'Det här tar bort denna delade kundvagn för alla organisationer där den har delats.',
  sharedCartOrganizationContent: 'Välj organisationer som kan använda denna delade kundvagn.',
  sharedShoppingCartsEnabled: 'Aktivera delade kundvagnar',
  shoppingCartExportJob: 'Exportera Kundvagn',
  shoppingCartLoadingLongTime: 'Kundvagnen laddas. Ikonerna för kundvagnen kommer att bli tillgängliga när processen slutförts. Om problemet kvarstår, vänligen kontakta din Documoto-administratör för hjälp.',
  showChapterTOCForHiddenPages: 'Visa innehållsförteckning över kapitel för dolda sidor',
  showExportFromSearch: 'Tillåt export från sökresultat',
  showExportFromSearchHelp: 'Tillåt export av boklista från en sökning',
  showHelp: 'Visa Hjälp',
  showIdentifierInLibrary: 'Visa medieförteckning och produktsidor i biblioteket',
  showIdentifierInSearch: 'Visa Media-identifierare i sökningen',
  showItem: 'Visa {item}',
  showLess: 'Visa färre',
  showMediaDescriptionFilter: 'Visa beskrivningsfilter för medier',
  showMediaIdentifierFilter: 'Visa identifieringsfilter för medier',
  showMediaNameFilter: 'Visa namnfilter för medier',
  showMore: 'Visa fler',
  showOnlyExactMatches: 'Visa endast exakta matchningar',
  showOrganizationFilter: 'Visa organisationsfilter',
  showPartNameFilter: 'Visa filter för artikelnamn',
  showPartNumberFilter: 'Visa filter för artikelnummer',
  showRecentlyAdded: 'Visa nyligen tillagda',
  showRecentlyViewed: 'Visa nyligen visade',
  showSearchButton: 'Visa sökknapp på startsidan',
  showSearchButtonHelp: 'Visa knappen \'Gå till sökning\' i bibliotekssidhuvudet',
  signature: 'Underskrift',
  size: 'Storlek',
  snapshot: 'Ögonblicksbild | Ögonblicksbilder',
  solrSlaveSvrOverride: 'Åsidosätt SOLR slav-servrars grundläggande URL',
  sortAsc: '{value} A-Ö',
  sortDesc: '{value} Ö-A',
  sortRelevant: 'Mest relevant',
  sortType: 'Sorteringstyp',
  sourceBrowseFlow: 'Källans flöde',
  sourceFile: 'Källfil',
  sourceFilename: 'Källfilens namn',
  spanishDescription: 'Beskrivning på spanska',
  spanishName: 'Spanskt Namn',
  square: 'Kvadrat',
  ssoConfiguration: 'SSO-konfigurering',
  ssoIdpMetadataUrl: 'URL för SSO IDP-metadata',
  ssoLoginMaxAuthenticationAgeSeconds: 'Maximal autentiseringsålder i sekunder för SSO-inloggning',
  ssoSamlDnAttributeName: 'SSO SAML DN-namn på attribut',
  ssoSamlEmailAttributeName: 'SSO SAML-namn på mejlattribut',
  ssoSamlMemberofAttributeName: 'SSO SAML-namn på attribut MemberOf',
  ssoSniForSsoMetadataRetrieval: 'Använd SNI för att hämta metadata för SSO',
  standard: 'Standard',
  standardUserGroup: 'Vanlig användargrupp',
  startDate: 'Startdatum',
  startDateRequired: 'Ett startdatum krävs.',
  state: 'Delstat',
  'static': 'Statisk',
  status: 'Status',
  statusCode: 'Statuskod | Statuskoder',
  stitchPages: 'Sammanfoga sidor',
  storeFilterValues: 'Lagra filtervärden',
  storeFilterValuesDescription: 'Aktivering av denna inställning lagrar de värden som användare ställt in för sina filter på söksidan för denna tagg.',
  storeFrontAdmin: 'Butiksadmin',
  storefront: 'Butik',
  storefrontIntegration: 'Butiksintegration | Butiksintegrationer',
  storefrontIntegrationSubtitle: 'Dessa inställningar styr olika element och alternativ inom butiksintegration. Var försiktig när du utför ändringar. Kontakta Documoto Support för mer information.',
  storefrontSettings: 'Butiksinställningar',
  storefrontSettingsDescription: 'Dessa inställningar styr olika element och alternativ inom butiken. Var försiktig när du utför ändringar. Kontakta Documoto Services för mer information.',
  storefrontSettingsOrgDescription: 'Dessa inställningar styr olika element och alternativ inom butiken på organisationsnivå. Var försiktig när du utför ändringar. Kontakta Documoto Services för mer information.',
  stroke: 'Slag',
  style: 'Stil | Stilar',
  styles: {
    colorHotpoint: 'Standard Hotpoint',
    inheritedFromOrg: 'Ärvd från organisation {org}',
    inheritedFromSystem: 'Ärvd från systemets standardvärde',
    inheritedFromTenant: 'Ärvd från hyresgäst',
    invalidHexcode: 'Ogiltig hex-kod',
    organization: 'Organisationsstil | Organisationsstilar',
    organizationSaved: 'Organisationsstilar har sparats',
    sampleNavigation: 'Navigeringsflikar',
    samplePrimary: 'Navigering / knappar',
    sampleSelectedHotpoint: 'Valda Hotpoints',
    tenant: 'Stil för hyresgäst | Stilar för hyresgäster',
    tenantSaved: 'Stilar för hyresgäster har sparats'
  },
  subChapter: 'Underkapitel | Underkapitel',
  subject: 'Ämne',
  subjectMessage: 'Ett ämne krävs',
  submit: 'Skicka',
  submitPurchaseOrder: 'Inköpsorder',
  submitRequestForQuote: 'Offertförfrågan',
  submitted: 'Skickad',
  submittedBy: 'Skickad av',
  submittedFilesMessage: 'Skickade {fileCount} fil(er).',
  submitter: 'Avsändare',
  submitterEmail: 'Insändarens mejl',
  submitterFirstName: 'Insändarens förnamn',
  submitterLastName: 'Insändarens efternamn',
  submitterOrgName: 'Insändarens organisations namn',
  submitterUserName: 'Insändarens användarnamn',
  success: 'Slutfört',
  successNotificationDuration: 'Lägg till i Kundvagn – Varaktighet för Meddelande om Slutförande',
  suffix: 'Suffix | Suffix',
  suggestedKeywords: 'Föreslagna nyckelord',
  suggestedResults: 'Föreslagna resultat',
  suggestion: 'Förslag | Förslag',
  sun: 'Sön',
  superAdminSettings: 'Inställningar för Super Admin',
  superadmin: 'Superadmin',
  supersede: 'Ersätt',
  supersedeComplete: 'Vill du slutföra ersättningen?',
  supersedeDiscardChanges: 'Ignorera din ersättning?',
  supersedeMainText: 'Ersättning ersätter en befintlig artikel med en eller flera andra artiklar på varje artikelsida som innehåller den gamla artikeln. Det gamla artikelnumret tas bort men förblir sökbart via taggar så att det går att hitta innehåll med det gamla numret eller det nya numret/numren.',
  supersedeMessage: 'Artikeluppdateringar träder i kraft omedelbart. Uppdateringarna visas i sökning inom några minuter.',
  supersedeNotProcessed: 'Din ersättning bearbetas inte.',
  supersedeReplacePart: 'Hitta en eller flera artiklar som ska ersätta artikeln',
  supersedeSuccessful: 'Ersättningen lyckades',
  supersedeWith: 'Ersätt artikel med ...',
  superseded: 'Ersatt',
  supersededParts: 'Ersatta delar',
  supplier: 'Leverantör | Leverantörer',
  supplierDescription: 'Företaget som tillhandahåller denna artikel',
  supplierKey: 'Leverantörsnyckel',
  supportedDraftArchives: 'Filen stöds inte; utkastfiler som stöds: MDZ, PLZ',
  supportedImageFormats: 'Bildformat som stöds: GIF, JPG, JPEG, PNG',
  surroundWithQuotes: 'Använd citattecken runt flera söktermer för en exakt sökträff.',
  svgFinder: 'SVG-Sökare',
  swedishDescription: 'Beskrivning på svenska',
  swedishName: 'Svenskt Namn',
  system: 'System',
  systemAdmin: 'Systemadmin',
  systemFieldSearchAndFiltering: 'Sökning och filtrering för systemfältet',
  systemFields: 'Systemfält',
  systemName: 'Namn på systemet',
  systemStatus: 'Systemstatus',
  systemVersion: 'Systemversion',
  tabDelimited: 'Tabbavgränsad',
  tableOfContents: 'Innehållsförteckning',
  tabloid: 'Tabloid',
  tag: 'Tagg | Taggar',
  tagDeleteAffectedCount: 'Detta tar bort taggen och tar bort tagginformationen från {count} objekt.',
  tagDeleteAffectedNone: 'Inga objekt använder denna tagg för närvarande.',
  tagEditor: {
    filterPrompt: 'Visar de första 100 värdena. Använd filter för att visa fler.',
    rangeBoundLengthInvalid: 'Bindning får inte ha mer än {limit} siffror.',
    tagEditorModal: 'Taggredigerare modal',
    textfieldHelpText: 'Ange ett eller flera värden separerade med semikolon. Exempel: SN001; SN002'
  },
  tagManagerDeleteWarning: 'All befintlig media med {deleteCategoryName} förlorar denna kategori efter radering.',
  tagName: 'Namn på tagg',
  tagSearchAndFiltering: 'Taggsökning och filtrering',
  tagSearchAndFilteringHelpText: 'Tips: några inställningar för sökning och filtrering kan även konfigureras i redigerare för tagghantering, som finns här: ',
  tagSubmitAffected: 'Allt {type} innehåll förlorar taggen {tag} när ändringarna görs.',
  tagValue: 'Taggvärde | Taggvärden',
  tagValueMissing: 'Du måste ange ett taggvärde',
  tagValueMultiple: 'Semikolonseparerat för flera poster',
  tagValueTooLong: 'Taggvärde överskrider gränsen på 25 tecken | Taggvärden överskrider gränsen på 25 tecken',
  tagsDeleteError: 'En eller flera taggar kunde inte raderas',
  tagsDeleteSuccess: 'Taggar har raderats',
  tagsDisplayMore: 'Visar de första 100 värdena. Använd filter för att visa fler.',
  tagsManager: 'Tagghanterare',
  tagsSaveError: 'En eller flera taggar kunde inte sparas',
  tagsSaveSuccess: 'Taggar sparade',
  tagsUpdateError: 'en eller flera uppdateringar av taggar misslyckades',
  tagsUpdateSuccess: 'Taggar uppdaterade',
  targetBrowseFlow: 'Målets flöde',
  taxon: 'Taxon',
  taxonomy: 'Taxonomi',
  template: 'Mall | Mallar',
  templateEmailRecipients: 'Mallens e-postmottagare',
  templateLayout: {
    addItem: 'Lägg till artikel',
    addRow: 'Lägg till rad',
    deleteColumn: 'Radera kolumn',
    deleteRow: 'Radera rad',
    fullWidth: 'Fullständig bredd',
    oneColumn: 'En kolumn',
    threeColumns: 'Tre kolumner',
    twoColumns: 'Två kolumner'
  },
  tenant: 'Innehavare | Innehavare',
  tenantAdmin: 'Innehavaradmin',
  tenantAdminMessage: 'Styr alla inställningar för innehavaren',
  tenantCleanerJob: 'Underhåll av innehavare',
  tenantConfiguration: 'Konfigurering av hyresgäst',
  tenantEmailRecipients: 'Klientens e-postmottagare',
  tenantEmailRecipientsOverrideMessage: 'Dessa kommer att åsidosättas om organisationens e-postmottagare specificeras',
  tenantIndexQueueJob: 'Indexkö för innehavare',
  tenantKey: 'Hyresgästens nyckel',
  tenantKeyError: 'Hyresgästens nyckel är inte unik',
  tenantKeyMessage: 'Hyresgästens nyckel måste vara unik',
  tenantLabelDeleteMessage: 'Om du raderar denna etikett används Documoto-namnet som standard.',
  tenantLabelsPageText: 'Etiketter används för att anpassa namnen på många objekt som finns på Documotos biblioteks- och administrationsskärmar.',
  tenantPrintSettingsDescription: 'Välj standard utskriftsinställning för innehavaren. Denna inställning används för alla bokutskrifter om den inte åsidosätts av organisationen eller media.',
  tenantReindexModulus: 'Hyresgästens Reindex-modul',
  tenantSettings: {
    collapseTOCLabel: 'Minimera innehållsförteckning på matchande sida',
    defaultLocaleLabel: 'Standardplats',
    defaultLocaleMessage: 'Innehavarens standardplats.',
    defaultSupplierLabel: 'Standardleverantör',
    defaultSupplierMessage: 'Innehavarens standardleverantör.',
    deleteMissingTranslationsOnPublishLabel: 'Radera översättningar som saknas vid publicering?',
    deleteMissingTranslationsOnPublishMessage: 'Aktivera för att radera översatta delar vid publicering',
    enableChapterIndexingLabel: 'Slår på indexering för mediakapitel',
    enableChapterIndexingMessage: 'Kapitelindexering',
    enableIndexingLabel: 'Index på Publicering',
    enableIndexingMessage: 'Aktiverar indexering för publicering.',
    excludePartsFromAccessControlChecksLabel: 'Exkludera delar från åtkomstkontrollens regler',
    excludePartsFromAccessControlChecksMessage: 'När den aktiveras, är delar synliga för alla användare oavsett åtkomstkontrollernas media.',
    exportPgAsHashLabel: 'Exportera namn på sidfilen som hashnyckel',
    exportPgAsHashMessage: 'Använd sidans hashnycklar som namn på sidfiler i innehåll som exporteras',
    helpUrlLabel: 'Standard URL för Hjälp',
    helpUrlMessage: 'URL för ett annat hjälpsystem.',
    hotPointLinkPageInBookOnlyLabel: 'Länkar till Sidans Höjdpunkter Endast i Bok',
    hotPointLinkPageInBookOnlyMessage: 'Länkar till Höjdpunkter Endast från Bokens Sidor',
    lockPartTrOnPublishLabel: 'Lås delar av översättning vid publicering',
    lockPartTrOnPublishMessage: 'Förhindrar att delar av översättning modifieras vid publicering',
    mediaTimestampLabel: 'Uppdatera mediatidsstämpel vid ändring av åtkomstkontroll',
    mediaTimestampMessage: 'Aktivera om en ändring i mediekategorier för åtkomstkontroll ska uppdatera medias tidsstämpel.',
    publisherDefaultUom: 'Utgivarens förinställda UOM',
    publishingContactLabel: 'E-postadress för publiceringskontakt',
    publishingContactMessage: 'E-postadressen som tar emot meddelanden som standard när innehållsproblem rapporteras.',
    replaceHotpointLabel: 'Ersätt alltid hotpoint-länkar vid publicering',
    replaceHotpointMessage: 'Endast för Docustudio-publicering.',
    ssoLoginSystemLabel: 'SSO InloggningsSystem',
    ssoLoginSystemMessage: 'IdentitetsLeverantörssystem för SSO.',
    userPasswordExpirationLabel: 'Dagar tills användarens lösenord går ut',
    userPasswordExpirationMessage: 'Antal dagar tills lösenordet måste bytas; lämna blankt för ett lösenord som aldrig går ut'
  },
  tenantSettingsSaved: 'Inställningar för Innehavare har Sparats',
  tenantSettingsSubtitle: 'Dessa inställningar styr egenskaper och beteenden för alla innehavare. Var försiktig när ändringar utförs. Kontakta Documoto Services för ytterligare information.',
  tenantSettingsTitle: 'Inställningar för Innehavare',
  tenantSuppliers: 'Hyresgästers leverantörer',
  tenantType: 'Typ av hyresgäst',
  tenantWebserviceUser: 'Hyresgästens webbtjänst-användare',
  text: 'Text',
  textArea: 'Textområde',
  textColor: 'Textfärg',
  textField: 'Textfält',
  textFile: 'Textfil (CSV, TXT)',
  textTool: 'Textverktyg',
  threeD: {
    addFile: 'Lägg till en fil för en 3D-artikel',
    beforeSaveModal: {
      message: 'Vill du ersätta denna fil på alla dess platser eller endast koppla den till denna artikel? Om du väljer att ersätta filen så kommer följande att ske:',
      messageBulletOne: '{count} artikel / artiklar kommer att uppdateras med den nya CAD-filen',
      messageBulletOneForContent: '{count} {contentType} kommer att uppdateras med den nya CAD-filen',
      messageBulletTwo: 'Filens föregående version kommer att raderas från Documotos filsystem',
      tip: 'Tips: För att förhindra att någon fil skrivs över under denna process så kan du ändra filnamnet på filen du försöker koppla innan du importerar den.',
      title: 'En CAD-fil med detta filnamn finns redan i Documoto.'
    },
    deleteTitle: 'Är du säker på att du vill ta bort den här 3D-vyn?',
    drawMode: {
      hiddenLines: 'Dolda linjer',
      label: 'Ritläge',
      shaded: 'Skuggad',
      wireframe: 'Trådram',
      wireframeShaded: 'Skuggad trådram'
    },
    explode: 'Explodera',
    failureCreatingBomAssociations: 'Det gick inte att skapa kopplingar mellan 3D-modellen och BOM.',
    fileSizeModal: {
      message: 'Den största storleken på filer i Documoto är 25 megabyte. Filen som du försöker ladda upp har överskridit maximal storlek och kan inte laddas. Klicka på "OK" för att fortsätta.',
      title: 'Maximal filstorlek har överskridits'
    },
    fileSizeModalWarning: {
      message: 'Den maximala tillåtna fristående filstorleken i Documoto är {size} megabyte. En av filerna som du försöker ladda upp har överskridit maximum och kan inte laddas. Klicka på "OK" för att fortsätta.',
      title: 'Maximal filstorlek har överskridits'
    },
    freeTierCurrentCount: 'Du har {count} av 15 aktiva gratis nivåer av 3D-modeller. När du når gränsen kan du inte längre publicera nya sidor med 3D-modeller. Kontakta din Customer Success Manager för att uppgradera ditt abonnemang.',
    freeTierExceededError: 'Att publicera denna sida med en 3D-modell är inte tillåtet.',
    freeTierExceededOption1: 'Kontakta din Customer Success Manager för att uppgradera ditt abonnemang.',
    freeTierExceededOption2: 'Ta bort 3D-modellen från sidutkastet för att publicera den.',
    freeTierExceededTitle: 'Du har överskridit gränsen för 15 aktiva 3D-modeller',
    illustrationLabel: '2D-vy',
    invalidFile: 'Ogiltig fil skickad för uppladdning',
    mapModelToBom: 'Koppla modell till BOM',
    modelLabel: '3D-modell',
    modelLabelMobile: '3D',
    noBomPartsMatch3dPartNumbers: 'Inga BOM-delar som matchar 3D-modellens artikelnummer hittades',
    noPartsMatchRegEx: 'Inga BOM-delar matchar vanliga uttryck',
    orientation: 'Orientering',
    orientationAndProjection: {
      back: 'Tillbaka',
      bottom: 'Undersida',
      front: 'Framsida',
      isometric: 'Isometrisk',
      left: 'Vänster',
      orthographic: 'Ortografisk',
      perspective: 'Perspektiv',
      projection: 'Projektion',
      right: 'Höger',
      top: 'Ovansida'
    },
    partNumberProperty: 'Artikelnummer synligt',
    partNumberRegex: 'Artikelnummer Regex',
    partNumbersInModel: 'Artikelnummer för modellen',
    resetCamera: 'Återställ kamera',
    setAsDefaultView: 'Välj som standardvy',
    setAsDefaultViewTooltip: 'Ställ in denna riktning och zoomnivå som standardvy.',
    slice: {
      label: 'Skiva',
      planeX: 'Skärplan X',
      planeY: 'Skärplan Y',
      planeZ: 'Skärplan Z',
      reset: 'Återställ skärplan',
      section: 'Växla sektion för skärplan',
      visibility: 'Växla synlighet på skärplan'
    },
    successfullyCreatedBomAssociations: 'BOM-kopplingar för 3D-modell {count} har skapats',
    successfullySavedDefaultView: 'Standardvy har sparats',
    supportedFilesMessage: 'Documoto stödjer många olika format på CAD-filer. Se supportcentralen om du är osäker på om ditt CAD-filformat stöds.',
    threeD: '3D',
    toolsLabel: '3D-verktyg',
    topAssemblyFilename: 'Filnamn på övre montering',
    topAssemblyFilenameInvalid: 'Huvudmonteringsfilen finns inte i filförteckningen',
    topAssemblyFilenameRequired: 'Ett filnamn krävs för övre montering',
    viewerControls: 'Vyinställningar',
    viewerSettings: '3D vyinställningar',
    viewerTitle: '3D-vy'
  },
  thu: 'Tor',
  thumbnail: 'Miniatyrbild',
  thumbnailDeleted: 'Miniatyrbilden har tagits bort',
  thumbnailDeletedError: 'Det gick inte att ta bort miniatyrbilden',
  thumbnailReapplyWarning: 'Systemet kan tillämpa en miniatyrbild igen baserat på medieinnehållet. Detta kan ta några minuter.',
  thumbnailResizeTooltip: 'Ändrar storlek på miniatyrer till maximalt 500x500 pixlar om detta är valt',
  thumbnailUpdated: 'Miniatyrbilden har uppdaterats',
  thumbnailUpdatedError: 'Det gick inte att uppdatera miniatyrbilden',
  title: 'Titel',
  to: 'Till',
  toDate: 'Till datumet',
  toGetStarted: 'för att sätta igång.',
  toastNotifications: 'Meddelanden',
  toc: 'Innehållsförteckning',
  tocClipBoardSuccessTitle: 'Kopierat till Urklipp',
  tocClipBoardWarningText: 'VARNING: Det går inte att kopiera osparade ändringar till dina urklipp',
  tocClipBoardWarningTitle: 'Kopierat till Urklipp',
  tocDisplayingFirstValues: 'Visar de första 100 värdena. Använd filter för att visa fler.',
  tocDuplicateWarningText: 'Dubblettsida hittades i ett kapitel. Dubblettsidan har tagits bort.',
  tocEmptyMessage: 'Det verkar som att du inte har skapat någon innehållsförteckning än',
  tocMissingChapterName: 'Kapitelnamn saknas',
  tocModalTableCaption: 'Taggredigerare modal',
  tocNothingSelected: 'Inget valt',
  tocOpenEditor: 'Öppna redigerare',
  tocSaveRequired: 'Du måste spara innan du redigerar kapitelinformation',
  tocState: 'Innehållsförteckningens ursprungliga status',
  tocThumbnailDeleteFailTitle: 'Det gick inte att ta bort miniatyrbilden',
  tocThumbnailDeleteSuccessTitle: 'Miniatyrbilden togs bort',
  tocThumbnailUploadFailTitle: 'Det gick inte att ladda upp miniatyrbilden',
  tocThumbnailUploadSuccessTitle: 'Miniatyrbilden har laddats upp',
  tocTranslationMessage: 'Namn på och valfri beskrivning av detta kapitel',
  tocUntitledPage: 'Namnlös sida',
  togglePage: 'Växla Sida',
  tooManySelections: 'Listan överskrider begränsningen på {limit} val',
  top: 'Överst',
  total: 'Summa',
  totalItems: 'Objekt totalt',
  translation: 'Översättning | Översättningar',
  translationHelpTextItem: 'Namn på och valfri beskrivning av denna {item}',
  'true': 'Sant',
  tryAgain: 'Försök igen.',
  trySearchingToc: 'Prova att söka efter ett ord du ser eller kommer ihåg – listan begränsas direkt. Vyn ändras inte förrän du klickar på ett resultat.',
  tryThis: 'Prova detta',
  tue: 'Tis',
  turkishDescription: 'Beskrivning på turkiska',
  turkishName: 'Turkiskt Namn',
  twoSided: 'Dubbelsidig',
  type: 'Typ | Typer',
  typeAtLeastTwoChars: 'Skriv åtminstone två bokstäver för att se en lista med träffar.',
  typeSearchCriteriaAlreadySet: 'Radera valda sökkriterier "Typ" för att tillämpa ändringarna.',
  typeToConfirm: 'Typ {value} som ska bekräftas',
  typography: 'Typografi',
  ukraineDescription: 'Beskrivning på ukrainska',
  ukraineName: 'Ukrainskt Namn',
  unableToRetrieveResults: 'Det gick inte att hämta resultat för din sökning',
  unauthorized: 'Obehörig',
  unknownError: 'Okänt fel, kontakta Documoto support på support{\'@\'}documoto.com för hjälp',
  unknownInput: 'Okänd typ av indata:',
  unknownPart: 'Okänd artikel',
  unknownType: 'Okänd typ',
  unsavedAPIKeyWarning: 'Din API-Nyckel kommer att gå förlorad om du inte Går tillbaka',
  unsavedChanges: 'Dina ändringar har inte sparats. Fortsätt?',
  unsavedChangesWarning: 'Dina ändringar kommer att förloras om du inte sparar dem.',
  unsavedWidgetKeyWarning: 'Din widgetnyckel kommer att gå förlorad om du inte återvänder.',
  unsupportedBrowserMessage: 'Vi har byggt det här programmet med den senaste teknologin. Det gör att programmet är snabbare och lättare att använda. Tyvärr stöder inte din webbläsare den här teknologin.',
  untitledOrg: 'Namnlös organisation',
  unverified: 'Icke verifierad',
  uom: 'Enhet',
  update: 'Uppdatera',
  updateFailed: 'Uppdatering misslyckades',
  updateIndex: 'Uppdatera index',
  updatePassword: 'Uppdatera lösenord',
  updatePasswordMessage: 'Lösenord uppdaterat',
  updatePasswordPending: 'Lösenordsändring väntar på att sparas.',
  updated: 'Uppdaterad',
  upgradeBrowser: 'Vänligen uppgradera din webbläsare.',
  upload: 'Ladda upp',
  uploadComplete: 'Uppladdning slutförd',
  uploadFileSizeLimitExceeded: 'Filen överskrider den maximala filstorleken för visning i appen.',
  uploadInProgress: 'Uppladdning pågår',
  uponSavingDisabledTenant: 'När denna sida sparas med denna inställning aktiverad så kommer följande att ske:',
  uponSavingThisLicense: 'DU MÅSTE GÖRA FÖLJANDE när denna sida sparas med denna inställning:',
  upperBound: 'Övre gräns',
  usCurrency: 'USD',
  useDefaultCartColumns: 'Använd standardkolumner för kundvagn',
  useDefaultPartsListColumns: 'Använd standardkolumner för artikellista',
  useSequentialPageNumbering: 'Använd sekventiell sidnumrering',
  useSniForSsoMetadataRetrieval: 'Använd SNI för att hämta metadata för SSO',
  user: 'Användare',
  userAddress: 'Användaradresser | Användaradresser',
  userCount: 'Användarantal',
  userEditable: 'Går att redigera av Användare',
  userExpirationDate: 'Utgångsdatum för användare',
  userExpirationDateInvalid: 'Utgångsdatum för användare måste anges',
  userGroup: 'Användargrupp | Användargrupper',
  userGroupEmpty: 'Användargrupper får inte vara tomma',
  userGroupType: 'Typ av användargrupp',
  userGroupUniqueMessage: 'Detta namn får inte vara samma som något annat användargruppnamn för denna innehavare',
  userGroupUsers: 'Användare i användargrupper',
  userSettings: 'Användarinställningar',
  userVerificationEmailBody: 'Användarverifiering via e-post',
  userVerificationEmailFieldsValidation: 'Fälten för verifiering av användare via e-post måste antingen vara tomma eller båda ifyllda',
  userVerificationEmailSubject: 'E-postmeddelande för användarverifiering',
  username: 'Användarnamn',
  usernameEmpty: 'Användarnamnet får inte vara tomt',
  users: 'Användare',
  usersWillReceiveAnUnauthorizedError: 'Användare kommer att få ett felmeddelande om "Otillåten åtkomst" när de försöker logga in på hyresgästen.',
  validate: 'Bekräfta',
  validateTenantDirectories: {
    buttonLabel: 'Bekräfta kataloger med innehåll',
    error: 'Kunde inte bekräfta kataloger',
    success: 'Bekräftade hyresgästers kataloger'
  },
  validationMessage: 'Meddelande om bekräftelse | Meddelanden om bekräftelse',
  value: 'Värde',
  valueGteError: 'Värdet måste vara mindre än eller lika med {max}',
  valueLteError: 'Värdet måste vara större än eller lika med {min}',
  variantSKU: 'SKU-variant',
  vendorName: 'Namn på återförsäljare',
  verificationEmailRequested: 'Ett verifieringsmeddelande skickas när du sparar.',
  verificationEmailSent: 'E-postbekräftelse skickad. Lösenordet har inte angetts. ',
  verified: 'Verifierad',
  verifyPassword: 'Bekräfta lösenord',
  verifying: 'Verifierar',
  version: 'Version',
  vertical: 'Lodrät',
  video: 'Video | Videor',
  view: 'Vy',
  viewAll: 'Visa alla',
  viewAllPagesAndBooks: 'Granska: Alla sidor och böcker',
  viewAllResults: 'Visa alla resultat',
  viewBooks: 'Granska: Böcker',
  viewModeList: 'Listvy',
  viewModeTable: 'Tabellvy',
  viewMore: 'Visa mer',
  viewPages: 'Granska: Sidor',
  viewWhereUsed: 'Visa användningsplatser',
  views: 'Visningar',
  visibility: 'Synlighet',
  visibilityDescription: 'Vem kan se denna {entity}',
  visible: 'Synlig',
  waitForUpload: 'Vänta tills uppladdningen slutförs.',
  watermark: 'Vattenstämpel',
  watermarkFont: 'Teckensnitt för vattenstämpel',
  watermarkOpacityPercentage: 'Opacitet för vattenstämpel i procent',
  watermarkOrientation: 'Vattenstämpelns riktning',
  watermarkSaveFailed: 'Kunde inte spara vattenstämpel.',
  watermarkSaved: 'Vattenstämpel sparad',
  watermarkSelectionRequired: 'Val av användarnamn eller text krävs.',
  watermarkText: 'Text för vattenstämpel',
  wed: 'Ons',
  whereUsed: 'Var de används',
  whereUsedCountInSearchBar: 'Antal användningsställen i sökfältet',
  whoCanViewComment: 'Vem kan se denna kommentar?',
  wholesale: 'Grossisthandel',
  wholesalePrice: 'Grossistpris',
  wholesaleTotal: 'Summa grossisthandel',
  widget: 'Widget',
  widgetAuthHeader: 'Värde för godkännande av widget',
  widgetErrorConfig: 'Widgeten kunde inte initieras på grund av en felaktig widgetkonfiguration',
  widgetErrorInit: 'Det gick inte att initiera Documoto-widgeten',
  widgetErrorLocation: 'Det gick inte att hitta det angivna innehållet i widgeten',
  widgetErrorMultipleLocations: 'Flera platser hittades för det angivna innehållet',
  widgetKey: 'Widgetnyckel | Widgetnycklar',
  widgetKeyAdmin: 'Admin för widgetnyckel',
  widgetKeyCopied: 'Värde för godkännande av widget har kopierats till urklipp',
  widgetKeyDeleteMsg: 'Radering av widgetnyckel leder till att den inte kan användas',
  widgetKeyDeleted: 'Widgetnyckel har raderats',
  widgetKeyDeletedError: 'Fel vid radering av widgetnyckel',
  widgetKeyManager: 'Hantering av widgetnyckel',
  widgetKeyNameEmpty: 'Namnet måste vara unikt och är obligatoriskt. Detta värde kommer också att användas som ett användarnamn för all widgetaktivitet för rapportering och loggsyften',
  widgetKeyRegenError: 'Fel vid återskapande av widgetnyckel',
  widgetKeyRegenMsg: 'Återskapande av denna widgetnyckel kan inaktivera befintliga integrationer',
  widgetKeyRegenTitle: 'Är du säker på att du vill återskapa denna widgetnyckel?',
  widgetKeySaved: 'Widgetnyckeln har sparats',
  widgetPermissions: 'Widgetanvändare kan endast visas. Tillgång till funktioner hanteras av konfiguration på widgetnivå. Rättigheter för vanliga användargrupper gäller inte för widgetanvändare, då bör istället rättigheter för tillgång till mediakategorier användas. Vänligen fortsätt till tilldelning av rättigheter för tillgång till mediakategorier.',
  widgetRefreshErrorMsg: 'Vänligen uppdatera sidan för att se det begärda innehållet',
  widgetUserGroup: 'Användargrupp för widgetanvändare',
  widgetUserGroupDeleteMsg: 'Kan inte radera widgetgrupp med användare',
  willBeAffected: 'kommer att påverkas.',
  willBeDeleted: '{content} kommer att tas bort.',
  willBeInsertedIntoItem: '{name} kommer att infogas i {item}',
  willBeUpdated: 'kommer att uppdateras.',
  year: 'År',
  yourEmailAddress: 'Din e-postadress',
  zipCode: 'Postnummer',
  zoomHotpointToCanvas: 'Zooma Hotpoint till dukstorlek',
  zoomIn: 'Zooma In',
  zoomOut: 'Zooma Ut'
};
/* eslint-enable max-len */
